(function(){
    //<!-- BTOCSITE-60709 [구독-마이페이지] 연차 별 혜택 수정의 건 -->
    //케어십 - 14개월 미만
    var lb_careShip = '<div class="sects lb-pdlr lb-careShip">' +
    '<div class="latter-benefits_detail">' +
        '<div class="lb-cont">' +
            '<div class="lb-cont_top">' +
                '<div class="lb-head_cont">' +
                    '<h3>케어십 가입 기념 특별 혜택</h3>' +
                    '<p class="lb-term"><span class="lb-term-tit">혜택 유효 기간</span><span>{{ validStrDate }}</span> ~ <span>{{ validEndDate }}</span></p>' + //<!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 : 디자인 현행화 수정 -->
                '</div>' +
                '<p class="lb-top_text">' +
                    '고객님, 안녕하세요!<br>' +
                    'LG전자 케어십 가입에 감사드리며 가입일로부터 1년 이내 <span>가전 구독 제품 추가 가입 시 모바일 상품권</span>을 드립니다.<br>' +
                    '물, 공기 뿐만 아니라 라이프 스타일까지 한번에 가전 구독 하시고 추가 혜택까지 받아보세요!' +
                '</p>' +
            '</div>' +
            '<div class="lb-cont_bottom">' +
                '<div class="lb-icon">' +
                    '<i>' +
                        '<img src="/lg5-common/images/MYC/care/gift_20000_pc.png" class="pc" alt="신세계 모바일 상품권 20,000원 이미지">' +
                        // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일용 이미지 삭제 -->
                    '</i>' +
                '</div>' +
                '<div class="lb-bottom_text">' +
                    '<p class="lb-TTxt">이 메시지를 받으신 고객님께서 <span><br class="mob-only">가전 구독 추가 가입 시 혜택</span></p>' +
                    // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일용 이미지 추가 -->
                    '<div class="lb-icon">' +
                        '<i>' +
                            '<img src="/lg5-common/images/MYC/care/gift_20000_mobile.png" class="mobile" alt="신세계 모바일 상품권 20,000원 이미지">' +
                        '</i>' +
                    '</div>' +
                    // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일용 이미지 추가 -->
                    '<h5>모바일 상품권 관련 상세 기준</h5>' +
                    '<ul>' +
                        '<li>' +
                            '<p class="dt">- 지급일정 : </p>' +
                            '<p class="dd">추가 가입 제품 설치 익월말 계약자 휴대폰번호로 증정</p>' +
                        '</li>' +
                        '<li>' +
                            '<p class="dt">- 사용방법 :</p>' +
                            '<p class="dd">문자 메세지 내 인증번호로 상품교환처에서 상품권 교환(유효기간 1년)</p>' +
                        '</li>' +
                    '</ul>' +
                    '<span class="lb-bTxt">공급사 사정에 따라 타브랜드로 변경될 수 있습니다.</span>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>' +
'</div>';



    //1년 차 렌탈(케어솔루션)
    var lb_careSolution_1 = '<div class="sects lb-pdlr lb-careSolution_1">' +
	'<div class="latter-benefits_detail">' +
		'<div class="lb-cont">' +
			'<div class="lb-cont_top">' +
				'<div class="lb-head_cont">' +
					'<h3>가전 구독 1년 사용 기념 특별 혜택</h3>' +
					'<p class="lb-term"><span class="lb-term-tit">혜택 유효 기간</span><span>{{ validStrDate }}</span> ~ <span>{{ validEndDate }}</span></p>' + //<!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 : 디자인 현행화 수정 -->
				'</div>' +
				'<p class="lb-top_text">' +
				'고객님, 안녕하세요!<br>' +
				'고객님과 LG전자 가전 구독이 함께한 1년을 기념하여 <span>가전 구독 제품 추가 가입 시 모바일 상품권</span>을 드립니다.<br>' +
				'물, 공기 뿐만 아니라 라이프 스타일까지 한번에 가전 구독 하시고 추가 혜택까지 받아보세요!' +
				'</p>' +
				'</div>' +
				'<div class="lb-cont_bottom">' +
				'<div class="lb-icon">' +
					'<i>' +
                        '<img src="/lg5-common/images/MYC/care/gift_20000_pc.png" class="pc" alt="신세계 모바일 상품권 20,000원 이미지">' +
                        // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일 이미지 삭제 -->
					'</i>' +
				'</div>' +
				'<div class="lb-bottom_text">' +
					'<p class="lb-TTxt">이 메시지를 받으신 고객님께서 <span><br class="mob-only">가전 구독 추가 가입 시 혜택</span></p>' +
                    // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일용 이미지 추가 -->
                    '<div class="lb-icon">' +
                        '<i>' +
                            '<img src="/lg5-common/images/MYC/care/gift_20000_mobile.png" class="mobile" alt="신세계 모바일 상품권 20,000원 이미지">' +
                        '</i>' +
                    '</div>' +
                    // <!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : 모바일용 이미지 추가 -->
					'<h5>모바일 상품권 관련 상세 기준</h5>' +
					'<ul>' +
						'<li>' +
							'<p class="dt">- 지급일정 :</p>' +
							'<p class="dd">추가 가입 제품 설치 익월말 계약자 휴대폰번호로 증정</p>' +
						'</li>' +
						'<li>' +
							'<p class="dt">- 사용방법 :</p>' +
							'<p class="dd">문자 메세지 내 인증번호로 상품교환처에서 상품권 교환(유효기간 1년)</p>' +
						'</li>' +
					'</ul>' +
					'<span class="lb-bTxt">공급사 사정에 따라 타브랜드로 변경될 수 있습니다.</span>' +
				'</div>' +
			'</div>' +
		'</div>' +
	'</div>' +
'</div>';

    //5년 차 렌탈(케어솔루션)
    var lb_careSolution_5 = '<div class="sects lb-pdlr lb-careSolution_5">' +
	'<div class="latter-benefits_detail lb-5year">' +
		'<div class="lb-cont">' +
			'<div class="lb-cont_top cont_top-custom">' +
				'<div class="lb-head_cont">' +
					'<h3>가전 구독 <br class="mob-only">장기 사용 특별 혜택</h3>' +
					'<p class="lb-term"><span class="lb-term-tit">혜택 유효 기간</span><span>{{ validStrDate }}</span> ~ <span>{{ validEndDate }}</span></p>' + //<!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 : 디자인 현행화 수정 -->
				'</div>' +
				'<p class="lb-top_text">' +
				'고객님, 안녕하세요!<br>' +
				'LG전자 케어십을 이용해 주셔서 감사합니다.<br>' +
				'<span>고객님의 케어 서비스가 곧 종료</span>되어 안내드립니다.' +
				'</p>' +
			'</div>' +
			'<div class="lb-cont_img">' +
				'<div class="lb-img-cotent">' +
					'<div class="lb-cont-i_text pdr-custom">' +
						'<h3>' +
						'새 가전으로 바꿔보고 싶다면?<br>' +
						'‘가전 구독 계약’ 하세요!' +
						'</h3>' +
					'</div>' +
					'<div class="lb-cont-i_img">' +
						'<ul>' +
							'<li><img src="/lg5-common/images/MYC/care/benefit_img_1.jpg" alt="공기청정기 이미지"></li>' +
							'<li><img src="/lg5-common/images/MYC/care/benefit_img_2.jpg" alt="식기세척기 이미지"></li>' +
						'</ul>' +
					'</div>' +
				'</div>' +
				'<div class="lb-img-cotent">' +
					'<div class="lb-cont-i_text pdl-custom fl-r">' +
						'<h3>' +
						'내 가전제품, <br>지금처럼 안심하고 사용하고 싶다면?<br>' +
						'‘케어십’에 가입하세요!' +
						'</h3>' +
					'</div>' +
					'<div class="lb-cont-i_img fl-l">' +
						'<ul>' +
							'<li><img src="/lg5-common/images/MYC/care/benefit_img_3.jpg" alt="정수기 케어 이미지"></li>' +
							'<li><img src="/lg5-common/images/MYC/care/benefit_img_4.jpg" alt="공기청정기 상담 이미지"></li>' +
						'</ul>' +
					'</div>' +
				'</div>' +
			'</div>' +
			'<div class="lb-cont_bottom cont_bottom-custom">' +
				'<div class="lb-bottom_text">' +
					'<ul>' +
						'<li>' +
							'<p class="dt dt-custom">- </p>' +
							'<p class="dd dd-custom">' +
							'정수기 제품은 정기적인 세척관리와 필터교체를 하지 않을 경우 수질이 저하되어 위생상 문제가 발생할 수 있습니다.' +
							'</p>' +
						'</li>' +
						'<li>' +
							'<p class="dt dt-custom">- </p>' +
							'<p class="dd dd-custom">' +
							'서비스 종료 이후 케어십 가입시에는 필터초기화 비용이 발생할 수 있습니다.' +
							'</p>' +
						'</li>' +
					'</ul>' +
				'</div>' +
			'</div>' +
		'</div>' +
	'</div>' +
'</div>';

    var lb_subscription_5 = '<div class="sects lb-pdlr lb-careSolution_5">' +
        '<div class="latter-benefits_detail lb-5year">' +
            '<div class="lb-cont">' +
                '<div class="lb-cont_top cont_top-custom">' +
                <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                    '<div class="lb-head_cont">' +
                        '<h3>가전 구독 <br class="mob-only">장기 사용 특별 혜택</h3>' +
                        '<p class="lb-term"><span class="lb-term-tit">혜택 유효 기간</span><span>{{subScriptionStartDt}}</span> ~ <span>{{subScriptionEndDt}}</span></p>' + //<!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 : 디자인 현행화 수정 -->
                    '</div>' +
                    '<p class="lb-top_text">고객님, 안녕하세요!<br>'+
                    'LG전자 가전 구독의 장기 사용에 감사드리며, <br class="mob-only"><span>가전 구독 제품 재구독시 할인 혜택</span>을 드립니다.</p>'+
                    '<p class="lb-top_text">물, 공기 뿐만 아니라 라이프 스타일까지 한번에 가전 구독 재구독하시고 할인 혜택까지 받아보세요!</p>'+
                    <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                '</div>' +
                '<div class="lb-cont_img">' +
                '<div class="lb-img-cotent">' +
                    '<div class="lb-cont-i_text pdr-custom">' +
                        '<h3>' +
                            '새 가전으로 바꿔보고 싶다면?<br>' +
                            '‘가전 구독 재계약’ 하세요!' +
                        '</h3>' +
                        '<p>장기 사용 고객 재계약 시 월요금 할인!</p>' +
                        '<a href="#" class="btn border size-m arrow">재구독 하러가기</a>' + <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                    '</div>' +
                    '<div class="lb-cont-i_img">' +
                        <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                        '<ul>' +
                            '<li><img src="/lg5-common/images/MYC/care/benefit_img_5.jpg" alt="공기청정기 이미지"></li>' +
                            '<li><img src="/lg5-common/images/MYC/care/benefit_img_6.jpg" alt="정수기 이미지"></li>' + //<!-- BTOCSITE-77518 [웹앱 접근성 개선활동] 주문/청약_가전구독 추가 수정 : alt값 추가 수정 -->
                        '</ul>' +
                        <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                    '</div>' +
                '</div>' +
                '<div class="lb-img-cotent">' +
                    '<div class="lb-cont-i_text pdl-custom fl-r">' +
                        '<h3>' +
                            '내 가전제품, <br>지금처럼 안심하고 사용하고 싶다면?<br>' +
                            '‘케어십’에 가입하세요!' +
                        '</h3>' +
                    '</div>' +
                    '<div class="lb-cont-i_img fl-l">' +
                    <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                        '<ul>' +
                            '<li><img src="/lg5-common/images/MYC/care/benefit_img_7.jpg" alt="공기청정기 케어 이미지"></li>' +
                            '<li><img src="/lg5-common/images/MYC/care/benefit_img_8.jpg" alt="정수기 케어 이미지"></li>' +
                        '</ul>' +
                    <!-- BTOCSITE-60120 [구독 Task] Sales - 재구독 -->
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="lb-cont_bottom cont_bottom-custom">' +
                '<div class="lb-bottom_text">' +
                    '<ul>' +
                        '<li>' +
                           '<p class="dt dt-custom">- </p>' +
                           '<p class="dd dd-custom">' +
                           '정수기 제품은 정기적인 세척관리와 필터교체를 하지 않을 경우 수질이 저하되어 위생상 문제가 발생할 수 있습니다.' +
                           '</p>' +
                        '</li>' +
                        '<li>' +
                            '<p class="dt dt-custom">- </p>' +
                            '<p class="dd dd-custom">' +
                                '서비스 종료 이후 케어십 가입시에는 필터초기화 비용이 발생할 수 있습니다.' +
                            '</p>' +
                        '</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';
    
    
//<!-- //BTOCSITE-60709 [구독-마이페이지] 연차 별 혜택 수정의 건 -->

    var MODE_USER = "USER";
    var MODE_PAYMENT = "PAYMENT";
    var METHOD_CARD = "CARD";
    var METHOD_BANK = "BANK";
	var PAYMENT_METHOD_CODE = "C"; // BTOCSITE-11586 납부방법이 모두 동일하게 '계좌이체'로 출력되는 현상

    var CONTRACT_INFO;
    var CONTRACT_CARE; //BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성
    var INFO_MODIFY_CONFIRM;
    var INFO_MODIFY_SAVE;
    var PAYMENT_METHOD_CONFIRM;
    var PAYMENT_SAVE_URL;
    var ARS_AGREE_URL;
    var ARS_AGREE_CHECK_URL;
    var REQUEST_CONTRACT_URL;
    var MEMPOINT_DEDUCT_URL;
    var REQUSET_CARD_URL;
    var BANK_ACCOUNT_URL;
    var REFUND_ACCOUNT_SAVE_URL

    var mypage;
    var userInfoBlock, userModifyBlock;
    var paymentInfoBlock, paymentModifyBlock;
    var refundBlock, refundModifyBlock, refundBtn, refundSaveContractID; //환불계좌  
    var refundAccountCertSeq; //환불계좌 콜백 seq

    var userInfo = {};
    var cardInfo = {};
    var bankInfo = {};
    var refundInfo = {};
    var paymentMode;
    var newg = {};
    var newgContractId;

    var sendPaymentMethod;

    var paymentInfo = {};

    var userInfoValidation;

    var cardValidation, bankValidation, refundValidation;

    var txtMasking;

    var ajaxMethod = "POST";

    var requestPartnerCardYn = "";

    var CERTI_ID, BATCH_KEY, CTI_REQUEST_KEY;
    var REFUND_BANK_CODE, REFUND_BANK_NUM, REFUND_REQ;

    var arsAgree = 'N';
    var arsAgreeConfirm = 'N';
    var isClickedarsAgreeConfirmBtn = false;
    var isClickedarsAgreeConfirmCheckBtn = false;

	var careApplyCardCnt, associCardType, associCardStatus; //제휴카드 신청 현황(DB), 제휴카드명, 제휴카드 신청 현황(API) BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 add
	var contInfo; // 현재 선택된 계약정보 (BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 ADD)
    var transDay; // 출금일
    var transDayChangeYN = 'N'; //출금일 변경여부
    var paymentDate = ""; //변경할 출금일
    var custGb = ""; //P:고객/O:거래선(사업자)
    var bsnRgsNmb = ""; //사업자 번호
    var company = "";
    //마이페이지 > 구독서비스 옵션 변경하기,옵션 확인하기 관련 변수
    var $serviceOptPopup1;
    var $chkMaxPop;
    var $quantity;
    function init(){
        CONTRACT_INFO = $('.contents.mypage').data('contractInfoUrl');
		CONTRACT_CARE = $('.contents.mypage').data('contractCareUrl'); //BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성
        INFO_MODIFY_CONFIRM = $('.contents.mypage').data('modifyConfirmUrl');
        INFO_MODIFY_SAVE = $('.contents.mypage').data('modifySaveUrl');
        PAYMENT_METHOD_CONFIRM = $('.contents.mypage').data('paymentMethodUrl');
        PAYMENT_SAVE_URL = $('.contents.mypage').data('paymentSaveUrl');
        ARS_AGREE_URL = $('.contents.mypage').data('arsAgreeUrl');
        ARS_AGREE_CHECK_URL = $('.contents.mypage').data('arsAgreeCheckUrl');
        REQUEST_CONTRACT_URL = $('.contents.mypage').data('requestContractUrl');
        MEMPOINT_DEDUCT_URL = $('.contents.mypage').data('mempointDeductUrl');
        REQUSET_CARD_URL = $('.contents.mypage').data('requestCardUrl');
        BANK_ACCOUNT_URL = $('.contents.mypage').data('bankAccountUrl');
        REFUND_ACCOUNT_SAVE_URL = $('.contents.mypage').data('refundAccountSaveUrl');
    
        vcui.require(['ui/modal', 'ui/validation', 'ui/formatter', 'ui/tab', 'helper/textMasking'], function () {             
            setting();
            bindEvents();

            var firstData = $('select[name=contractInfo]').find('option:selected').val();

            if(firstData) changeContractInfo();
            else{
                if(requestPartnerCardYn == "Y"){
                    var nodata = mypage.find('.no-data').text();
                    mypage.find('.no-data').html("<p>" + nodata + "<br>케어솔루션 계약시 제휴카드를 신청하시면 더욱 편리한 이용이 가능합니다.</p>");
                }
                requestPartnerCardYn = ""
            }
        });
    }

    function setting(){
        mypage = $('.contents.mypage');
        refundBlock = $('.contents.mypage').find(".section-wrap .sects.refund-bank-sects");
        userInfoBlock = mypage.find(".section-wrap .sects.user.viewer");
        userModifyBlock = mypage.find(".section-wrap .sects.user.modify");

        paymentInfoBlock = mypage.find(".section-wrap .sects.payment.viewer");
        paymentModifyBlock = mypage.find(".section-wrap .sects.payment.new-form-style");

        refundBlock = mypage.find(".refund-bank.viewer");
        refundModifyBlock =  mypage.find(".refund-bank.modify");
        refundBtn = mypage.find('.btn-group.center.refund-bank.button');
        
        var register = {
            userTelephone: {
                required: true,
                errorMsg: "전화번호를 입력해주세요.",
                msgTarget: '.err-block'
            },
            userEmail:{
                required: true,
                errorMsg: "이메일 주소를 다시 확인해주세요.",
                msgTarget: '.err-block',
                pattern : /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            },
            actualUserName: {
                required: true,
                errorMsg: "이름을 입력해주세요.",
                msgTarget: '.err-block'
            },
            actualUserPhone: {
                required: true,
                errorMsg: "휴대폰 번호를 입력해주세요.",
                msgTarget: '.err-block'
            },
            actualUserTelephone: {
                required: true,
                errorMsg: "전화번호를 입력해주세요.",
                msgTarget: '.err-block'
            },
            //BTOCSITE-61265 [구독] 사은품신청>사은품 신청하기 주소 입력 이후 먹통됨
            rcvDtlAddr: {
                required: true,
                errorMsg: "상세주소를 입력해주세요.",
                msgTarget: '.err-address',
                pattern: /^[가-힣a-zA-Z0-9ㆍᆢ@(),-\s]+$/,
                validate : function(value){
                    var valTest = new RegExp(this.pattern);
                    if( value.replace(/\s|　/gi, '') == 0) {
                        this.msgTarget = '.err-address';
                        this.errorMsg = "상세주소를 입력해주세요.";
                        return false;
                    } else if(!valTest.test(value)){
                        this.msgTarget = '.err-address';
                        this.errorMsg = "@ ( ) - , 를 제외한 특수문자는 입력하실 수 없습니다.";
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        }
        userInfoValidation = new vcui.ui.Validation('.mypage .section-wrap .sects.user.modify',{register:register});
        userInfo = userInfoValidation.getAllValues();

        register = {
            paymentCard:{
                required: true,
                errorMsg: "신용카드의 카드사를 선택해주세요.",
                msgTarget: '.err-block'
            },
            paymentCardNumber: {
                required: true,
                errorMsg: "신용카드의 카드번호를 입력해주세요.",
                msgTarget: '.err-block'
            },
            paymentCardPeriod: {
                required: true,
                errorMsg: "신용카드의 유효기간을 정확히 입력해주세요.",
                msgTarget: '.err-block'
            }
        }
        cardValidation = new vcui.ui.Validation('.mypage .section-wrap .sects.payment.new-form-style .by-card',{register:register});
        cardInfo = cardValidation.getAllValues();

        registerRefund = {
            bankCd: {
                required: true,
                errorMsg: "계좌이체할 은행명을 선택해주세요.",
                msgTarget: '.err-block'
            },
            bankAccount: {
                required: true,
                errorMsg: "계좌번호를 정확히 입력해주세요.",
                msgTarget: '.err-block'
            }
        }
        
        refundValidation = new vcui.ui.Validation('.mypage .section-wrap .refund-bank.modify',{register:registerRefund});
        refundInfo = refundValidation.getAllValues();

        register = {
            paymentBank: {
                required: true,
                errorMsg: "계좌이체할 은행명을 선택해주세요.",
                msgTarget: '.err-block'
            },
            paymentBankNumber: {
                required: true,
                errorMsg: "계좌번호를 정확히 입력해주세요.",
                msgTarget: '.err-block'
            }
        }
        bankValidation = new vcui.ui.Validation('.mypage .section-wrap .sects.payment.new-form-style .by-bank',{register:register});
        bankInfo = bankValidation.getAllValues();

        txtMasking = new vcui.helper.TextMasking();

        requestPartnerCardYn = getHiddenData("requestPartnerCardYn");
        
    }

    function bindEvents(){
        mypage.find(".section-wrap .sects.viewer").on('click', '.tit-wrap button', function(e){
            e.preventDefault();

            sendChangeConfirm(this)
        });
        
        userModifyBlock.on('click', '.cancel-btn', function(e){
            e.preventDefault();

            saveUserInfoCancel();
        }).on('click', '.ok-btn', function(e){
            e.preventDefault();

            saveUserInfoOk()
        });

        paymentModifyBlock.on('click', '.paymentCardConfirm, .paymentBankConfirm', function(e){
            e.preventDefault();

            setPaymentMethodAbled(this);
        }).on('click', '#arsAgreeRequest', function(e){
            e.preventDefault();

            setArsAgreeConfirm();
        }).on('click', '#arsAgreeRequestCheck', function(e){
            e.preventDefault();
            arsAgreeConfirmCheck();
        }).on('change', 'input[name=selfClearingAgree]', function(e){
            var chk = $(this).prop('checked');
            if(chk){
                $(this).prop('checked', false);
                $('#popup-selfClearing').vcModal({opener:$(this)})
                .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
            }
        }).on('click', '.selfClearingAgree', function(e){
            e.preventDefault();
            $('#popup-selfClearing').vcModal({opener:$(this)})
            .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
        }).on('click', '.cancel-btn', function(e){
            e.preventDefault();

            savePaymentInfoCancel();
        }).on('click', '.ok-btn', function(e){
            e.preventDefault();

            savePaymentInfoOk();
        }).on('click','input[name=changeBtn]',function (e){
            var chk = $(this).prop('checked');
            if(chk){
                $('#payDay').show();
                $('#inputPayDat').hide();
                $('#paymentBtn').attr('disabled', false);
                transDayChangeYN = "Y";
            }else{
                $('input[name=mpaymentDate]').prop('checked', false);
                $('#payDay').hide();
                $('#inputPayDat').show();
                $('#sel-date').val(transDay);
                transDayChangeYN = "N";
                paymentDate = "";
                if(getHiddenData('paymentMethodConfirm') == "Y"){
                    $('#paymentBtn').attr('disabled', false);    
                }else{
                    $('#paymentBtn').attr('disabled', true);
                }
                
            }
            
        }).on('click','input[name=mpaymentDate]',function (e){
            paymentDate = $(this).val();
        }).on('focusout','input[name=paymentCardNumber]',function(e){
            changeMaskingText('#ipt-card1');
        }).on('focusout','input[name=paymentCardPeriod]',function(e){
            changeMaskingText('#ipt-card2');
        }).on('focusin','input[name=paymentCardNumber]',function(e){
            $(this).val($(this).data('realData'))
        }).on('focusin','input[name=paymentCardPeriod]',function(e){
            $(this).val($(this).data('realData'))
        }).on('change','input[name=paymentCardPeriod]',function(e){
            if(chkCardConfirm("card")){
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', false);
                setHiddenData('paymentMethodConfirm', "N");
            }else{
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', true);
                setHiddenData('paymentMethodConfirm', "N");
            }
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
            
            
        }).on('change','input[name=paymentCardNumber]',function(e){
            if(chkCardConfirm("card")){
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', false);
                setHiddenData('paymentMethodConfirm', "N");
            }else{
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', true);
                setHiddenData('paymentMethodConfirm', "N");
            }
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
            
        }).on('change','#slt-card1',function(e){
            if(chkCardConfirm("card")){
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', false);
                setHiddenData('paymentMethodConfirm', "N");
            }else{
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#cardConfirm').attr('disabled', true);
                setHiddenData('paymentMethodConfirm', "N");
            }
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
            
        }).on('click','input[name=method-pay]',function(e){
            changePaymentMode($(this).val());
            if($(this).val() == "card"){
                $('#cardMsg').hide();
                $('#cardConfirm').attr('disabled', true);
            }else{
                $('#bankMsg').hide();
                $('#bankConfirm').attr('disabled', true);
            }
            $('#arsAgreeRequest').attr('disabled', true);
            $('input[name=selfClearingAgree]').attr('disabled', true);
            $('input[name=selfClearingAgree]').prop('checked', false);
            $('#paymentBtn').attr('disabled', true);
            //하단문구
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
            setHiddenData('paymentMethodConfirm', "N");
            
        }).on('focusout','input[name=paymentBankNumber]',function(e){
            changeMaskingText('#ipt-bank2');
        }).on('focusin','input[name=paymentBankNumber]',function(e){
            $(this).val($(this).data('realData'))
        }).on('change','#slt-bank1',function(e){
            if(chkCardConfirm("bank")){
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#bankConfirm').attr('disabled', false);
                setHiddenData('paymentMethodConfirm', "N");
            }else{
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#bankConfirm').attr('disabled', true);
                setHiddenData('paymentMethodConfirm', "N");
            }
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
        }).on('change','input[name=paymentBankNumber]',function(e){
            if(chkCardConfirm("bank")){
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#bankConfirm').attr('disabled', false);
                setHiddenData('paymentMethodConfirm', "N");
            }else{
                $('#arsAgreeRequest').attr('disabled', true);
                $('input[name=selfClearingAgree]').attr('disabled', true);
                $('input[name=selfClearingAgree]').prop('checked', false);
                $('#paymentBtn').attr('disabled', true);
                $('#cardMsg').hide();
                $('#bankMsg').hide();
                $('#bankConfirm').attr('disabled', true);
                setHiddenData('paymentMethodConfirm', "N");
            }
            $('#arsAgreeCheckMsg').show();
            $('#agreeErrMsg').hide();
            $('#arsAgreeCheck').hide();
            $('#arsAgreeMsg').hide();
            $('#arsMsg').hide();
        });

        $('.mypage').on('click', '.contract-btn', function(e){
            e.preventDefault();
            
            if(userInfo.userEmail){
                $('#popup-contractIssue').find('.pop-conts .gray-txt-box p em').text(userInfo.userEmail);
    
                $('#popup-contractIssue').vcModal({opener:$(this)})
                .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
            } else{
                lgkorUI.alert("", {
                    title: "계약서를 받을 이메일 정보가 없습니다.<br>계약자 정보를 수정해주세요.",
                    ok: function(){
                        var movetop = $('.sects.user.viewer').offset().top - 80;
                        $('html, body').animate({scrollTop:movetop}, 120)
                    }
                }, '.user.sects.viewer .tit-wrap button'); // BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리
            }
        }).on('click', '.requestCard-btn', function(e){
            e.preventDefault();

            setRequestCard();
        // })
        // .on('click', '.paymenyList-btn', function(e){
        //     e.preventDefault();

        //     console.log("납부내역 조회");
    }).on('click', '.cancelConsult-btn', function(e){
        e.preventDefault();
        
        if (newg.contractInfo.contGrpNo) {
            cancelConsult();
        }else{
            window.location.href = "/my-page/care-solution-contract-status/cancel?contLineSeq=" + newgContractId;

        }
    });

    $('.contents.mypage').find(".section-wrap .sects.refund-bank-sects").on('click', '.btn.border.size', function(e){
        e.preventDefault();

        refundModify();
    }).on('click', '.form-wrap .forms .btn', function(e){
        e.preventDefault();

        setRefundMethodAbled(this);
        
    }).on('click', '.ok-btn', function(e){
        e.preventDefault();

        saveRefundInfoOk();
    });

    refundBtn.on('click','.cancel-btn', function(e){
        e.preventDefault();

        cancelRefundModify();
    });

        $('.mempoint-btn').on('click', function(e){
            e.preventDefault();

            showMempointModify();
        });
        $('.mempoint-info').on('click', '.cancel-btn', function(e){
            e.preventDefault();

            cancelMempointModify(true);
        }).on('click', '.ok-btn', function(e){
            e.preventDefault();

            okMempointModify();
        }).on('change', 'input[name=point-cancel]', function(e){
            e.preventDefault();
            
            $(this).prop('checked', true);
        });

        $('#popup-contractIssue').on('click', '.btn-group button.pink', function(e){
            e.preventDefault();

            sendRequestContract();
        })

        $('#popup-cardIssue').on('click', '.requestIssue-btn', function(e){
            e.preventDefault();

            requestCardIssue();
        });

        $('#popup-selfClearing').on('click', '.btn-group button.btn', function(e){
            e.preventDefault();

            var chk = $(this).index() ? true : false;
            paymentModifyBlock.find('input[name=selfClearingAgree]').prop('checked', chk);

            if(chk){
                $('#agreeMsg').hide();
                $('#popup-selfClearing').vcModal('close');
            } 
            
        });

        $('select[name="contractInfo"]').on('change', function(e){
            changeContractInfo();
        });

        // BTOCSITE-22701 :: 구독계약일때 옵션 확인 클릭시
        $('.mypage').on('click', '.selectOption-btn', function(e){
            e.preventDefault();

            if(contInfo.itemOptionType == "F" || contInfo.itemOptionType == "N") { // 옵션 확인하기
                if (contInfo.relateProductYn == "Y"){
                    var title = $('#chcked-option-pop0 .scrb-select-option dt strong');
                    var listBox = $('#chcked-option-pop0 .scrb-select-option .list-option').empty();                     

                    title.text(contInfo.deliveryGoodsTypeNm);                    

                    var li = '<li>' +
                                '<span class="sub">서비스 가능 모델</span>' +
                                '<span class="aside">'+ contInfo.modelCd +'</span>' +
                                '</li>';
                    listBox.append(li);

                    $('#chcked-option-pop0').vcModal();
                    
                } else {
                    var title = $('#chcked-option-pop1 .scrb-select-option dt strong');
                    var listBox = $('#chcked-option-pop1 .scrb-select-option .list-option').empty(); 
                    
                    title.text(contInfo.deliveryGoodsTypeNm);

                    contInfo.itemList.forEach(function(item, idx){
                        var li = '<li>' +
                                '<span class="sub">'+ item.SC_ITEM_DISPLAY_NM +'</span>' +
                                '<span class="aside">'+ item.SC_ITEM_QTY +'개</span>' +
                                '</li>';
                        listBox.append(li);
                    });
                    $('#chcked-option-pop1').vcModal();
                }                
            } 

            if (contInfo.itemOptionType == "S"){ //옵션 변경하기
                var title = $('#chcked-option-pop2 .scrb-select-option dt strong');
                var listBox = $('#chcked-option-pop2 .scrb-select-option .list-option').empty(); 
                
                title.text(contInfo.deliveryGoodsTypeNm);

                contInfo.itemList.forEach(function(item, idx){
                    var li = '<li>' +
                            '<span class="sub">'+ item.SC_ITEM_DISPLAY_NM +'</span>' +
                            '<span class="aside">'+ item.SC_ITEM_QTY +'개</span>' +
                            '</li>';
                    listBox.append(li);
                });

                $('#chcked-option-pop2').vcModal();
            }
            
        });
        // BTOCSITE-22701 :: 옵션 확인 및 변경 팝업에서 변경하기 클릭
        $('#chcked-option-pop2').find('button.btn').on('click', function(e){
            e.preventDefault();
            $('#select-option-pop').trigger('modify', {
                contInfo : contInfo,
                modifySubmitUrl : $('.contents.mypage').data('modifyContUrl'),
                sendAfterCallback : function(){
                    $('#select-option-pop').vcModal('hide');
                    $('#chcked-option-pop2').vcModal('hide');
                    changeContractInfo();
                }
            });
        });

        // [S] BTOCSITE-84944 마이페이지 구독관리 메뉴 개선 // 계약현황 고정 탭 동작
        $('.contents.mypage').off('click.tab keydown.tab').on('click.tab keydown.tab', '.KRP1201 .tab-menu a', function(e) {
            var $this = $(this);
            var $tabWrap = $this.closest('.tab-menu');
            var $tabMenuWrap = $this.closest('.set-prod-tabmenu-wrap');

            if (e.type === 'click') {
                e.preventDefault();
                moveAnchorScroll($this);
            }

            if (e.type === 'keydown' && e.keyCode === 9 && !e.shiftKey && !$tabMenuWrap.hasClass('expanded')) {
                if ($tabWrap.next('li').length) {
                    if ($(window).width() < $tabWrap.next('li').offset().left) {
                        e.preventDefault();
                        var smoothScroll = $this.closest('.ui_smooth_scroll').vcSmoothScroll('instance')
                        var maxScrollX = smoothScroll.getMaxScrollX();

                        smoothScroll.scrollToElement($tabWrap.next('li')[0], 0);
                        $tabWrap.next('li').find('a').focus();
                    }
                }
            }
        });

        $('.contents.mypage').off('keydown.btn').on('keydown.btn', '.KRP1201 .btn-expand', function(e) {
            var $this = $(this);
            var $tabWrap = $this.closest('.tab-menu');
            var $tabMenuWrap = $this.closest('.set-prod-tabmenu-wrap');
            var $lastCont = $tabMenuWrap.find('.tab-menu').last();
            
            if (e.type === 'keydown' && e.keyCode === 9 && e.shiftKey && !$tabMenuWrap.hasClass('expanded')) {
                e.preventDefault();
                var smoothScroll = $this.prev('.ui_smooth_scroll').vcSmoothScroll('instance');
                
                smoothScroll.scrollToElement($lastCont[0], 0);
                $lastCont.find('a').focus();
            }
        });

        var anchorScroll = function(){
            $(window).off('scroll.improvedArea').on('scroll.improvedArea', function() {
                var $mypage = $('.contents.mypage');
                var $wrap = $mypage.find('#overview');
                var $conts = $wrap.find('>ul>li');
                var $tab = $mypage.find('.KRP1201');
                var $tabConts = $tab.find('.tab-menu');
                var tabH = $tab.height();
                var mobileNavH = $('.mobile-nav-wrap').is(':visible') ? $('.mobile-nav-wrap').height() : 0;
                var scrollTop = $(window).scrollTop();
                var helloBarH = 0;
                var windowH = $(window).height();
                var bodyH = $('body').height();
    
                $('.hello-bar-wrap').each(function() {
                    var $this = $(this);
                    
                    if ($this.is(':visible')) {
                        helloBarH += $this.height();
                    }
                });

                $conts.each(function() {
                    var $this = $(this);
                    var idx = $this.index();
    
                    if (windowH + scrollTop > bodyH -5) {
                        $tabConts.removeClass('on')
                        $tabConts.last().addClass('on');
                    } else if (scrollTop + tabH + mobileNavH + helloBarH > $this.offset().top) {
                        var $target = $tabConts.eq(idx);
                        $tabConts.removeClass('on')
                        $target.addClass('on');
                    }
                });
    
                if (!$tab.find('.set-prod-tabmenu-wrap').hasClass('expanded') && $tab.find('.ui_smooth_scroll').vcSmoothScroll('instance')) {
                    $tab.find('.ui_smooth_scroll').vcSmoothScroll('instance').scrollToActive(0);
                }
            });
        }

        function moveAnchorScroll($el, speed, callback) {
            var $this = $el;
            var $tabWrap = $this.closest('.tab-menu');
            var idx = $tabWrap.index();
            var $tabListWrap = $this.closest('.tab-menu-list');
            var $tabList = $tabListWrap.find('>li');
            var $mypage = $('.contents.mypage');
            var $wrap = $mypage.find('#overview');
            var $conts = $wrap.find('>ul>li');
            var targetContH = $conts.eq(idx).offset().top;
            var tabH = $this.closest('.KRP1201').height();
            var mobileNavH = $('.mobile-nav-wrap').is(':visible') ? $('.mobile-nav-wrap').height() : 0;
            var helloBarH = 0;

            $(window).off('scroll.improvedArea');

            $('.hello-bar-wrap').each(function() {
                var $this = $(this);
                if ($this.is(':visible')) {
                    helloBarH += $this.height();
                }
            });

            $('html, body').stop().animate({scrollTop: targetContH - tabH - mobileNavH - helloBarH + 5}, speed, function() {
                var $targetSection = $conts.eq(idx).find('.section-inner');

                $($tabList).each(function(){
                    $(this).removeClass('on');
                });

                $($tabWrap).addClass('on');

                $targetSection.attr('tabindex', 0);
                $targetSection.focus();
                $targetSection.one('focusout', function() {
                    $targetSection.removeAttr('tabindex');
                });
                $(window).scrollTop(targetContH - tabH - mobileNavH - helloBarH + 5);

                if (callback) callback();

                setTimeout(function() {
                    anchorScroll();
                }, 25);
            });
        }

        vcui.require(["ui/smoothScrollTab"], function () {
            anchorScroll();
            $(window).trigger('scroll');
        });
        // [E] BTOCSITE-84944 마이페이지 구독관리 메뉴 개선 // 계약현황 고정 탭 동작
        // [S] BTOCSITE-84944 마이페이지 구독관리 메뉴 개선 // 셀렉트 팝업 및 바텀 팝업 동작
        var popupId = $('.explan-prd-btn').attr('href');
        // 셀렉트 팝업 토글
        $('.explan-prd-btn, .mo_explan-prd-btn').click(function(e){
            e.preventDefault();
            if($(popupId).hasClass('active')){
                $(popupId).removeClass('active');
            }else {
                $(popupId).addClass('active');
                var isScrollBoxOuter = $(popupId).find('.subscribe-prd-scroll-list')[0].offsetWidth;
                var isScrollBoxInner = $(popupId).find('.subscribe-prd-scroll-list')[0].scrollWidth;
                var isScrollBoxPdL = parseFloat(getComputedStyle($(popupId).find('.subscribe-prd-scroll-list')[0]).paddingLeft);
                var scrollGap = isScrollBoxPdL - (isScrollBoxOuter - isScrollBoxInner);
                if(window.innerWidth > 768){
                    $(popupId).find('.subscribe-prd-scroll-list').css({'paddingRight': scrollGap+'px'});
                }
            }
        })
        // 셀렉트 팝업 닫침
        $('.sheet-close').click(function(e){
            e.preventDefault();
            $(popupId).removeClass('active');
        })
        // 셀렉트 선택시 on/off  팝업 닫침
        $('.subscribe-prd-scroll li label').each(function(i){
            $(this).click(function(e){
                e.preventDefault()
                $(this).parents('.subscribe-prd-scroll').find('li label').each(function(){
                    $(this).removeClass('on')
                });
                $(this).addClass('on');
                if($(popupId).hasClass('active')){
                    $(popupId).removeClass('active');
                }
            })
        })
        //납예 예정금액 상세보기
        $('.detail-summary-btn').find('button').click(function(e){
            e.preventDefault()
            if($('.detail-summary').hasClass('open')){
                $('.detail-summary').removeClass('open')
                $('.detail-summary').slideDown();
                $(this).find('span').text('접기')
            }else{
                $('.detail-summary').addClass('open');
                $('.detail-summary').slideUp();
                $(this).find('span').text('상세보기')
            }
        })
        // 스티키 탭 해더에 배너 있을경우
        var resizeObserver = new ResizeObserver(function(entries){
            if($('.explan-prd-btn').length){
                var dropDown = $('.explan-prd-btn').attr('href');;
                var isScrollBoxOuter = $(dropDown).find('.subscribe-prd-scroll-list')[0].offsetWidth;
                var isScrollBoxInner = $(dropDown).find('.subscribe-prd-scroll-list')[0].scrollWidth;
                var isScrollBoxPdL = parseFloat(getComputedStyle($(dropDown).find('.subscribe-prd-scroll-list')[0]).paddingLeft);
                var scrollGap = isScrollBoxPdL - (isScrollBoxOuter - isScrollBoxInner);
                if(window.innerWidth < 768){
                    $(dropDown).find('.subscribe-prd-scroll-list').css({'paddingRight': scrollGap+'px'});
                }else{
                    $(dropDown).find('.subscribe-prd-scroll-list').css({'paddingRight': scrollGap+'px'});
                }
            }
            if(window.innerWidth < 768){
                $('.improved-area .sign-tab-wrap').css({'top': entries[0].target.offsetHeight+ 'px'});
            }else{
                $('.improved-area .sign-tab-wrap').css({'top': '0px'});
            }
        });
        
        $('.header').length && resizeObserver.observe($('.header')[0]);
        // [E] BTOCSITE-84944 마이페이지 구독관리 메뉴 개선 // 셀렉트 팝업 및 바텀 팝업 동작
    }
    
    function chkCardConfirm(payment){
        if(payment == "card"){
            
             if($('input[name=paymentCardPeriod]').data('maxLength') > $('input[name=paymentCardPeriod]').val().length
                 || $('#slt-card1').val().length < 1){
                 return false;
             }
        }else{
            if($('input[name=paymentBankNumber]').data('maxLength') < $('input[name=paymentBankNumber]').val().length
                || $('#slt-bank1').val().length < 1){
                return false;
            }
        }

        return true;
    }

    // 차세대 계약 상품 해지신청 클릭시 계약건에 따른 해지상담 프로세스 적용
    function cancelConsult() {
        var contGrpNo = newg.contractInfo.contGrpNo;
        var mainYn = newg.contractInfo.mainYn;
        var optionFlag = newg.contractInfo.optionFlag;
        
        if (contGrpNo && mainYn !== "Y" && optionFlag === "F") {
            lgkorUI.alert("", {
                title: "본 계약건은 가전 구독서비스 필수선택 상품으로 단독 해지가 불가합니다."
            });
            
        }else if (contGrpNo && mainYn === "Y") {
            lgkorUI.confirm("", {
                title: "본 계약건은 가전 구독 메인상품으로 해지 시,<br> 함께 신청하셨던 모든 구독서비스가<br> 함께 해지됩니다.",
                okBtnName: "확인",
                ok: function(){
                    window.location.href = "/my-page/care-solution-contract-status/cancel?contLineSeq=" + newgContractId;
                }
            });
        }

        if (contGrpNo && mainYn !== "Y" && (optionFlag === "S" || optionFlag === "C")) {
            window.location.href = "/my-page/care-solution-contract-status/cancel?contLineSeq=" + newgContractId;
        }
    }

    //계약서 발급 신청
    function sendRequestContract(){
        var sendata = {
            userEmail:userInfo.userEmail,
            contractID: $('select[name=contractInfo]').find('option:selected').val(),
            contDtlType: contInfo.contDtlType,
            custGb : custGb
        }
        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(REQUEST_CONTRACT_URL, sendata, function(result){
            if(result.data.success == "Y"){
                $('#popup-contractIssue').vcModal('close');

                if(result.data.alert && result.data.alert.title){
                    lgkorUI.alert("", {
                        title: result.data.alert.title
                    });
                }
            } else{
                if(result.data.alert && result.data.alert.title){
                    lgkorUI.alert("", {
                        title: result.data.alert.title
                    });
                }
            }
        }, ajaxMethod);
    }

    //정보변경 확인...
    function sendChangeConfirm(item){

        var alertitle, alertmsg, sendata;
        var section = $(item).closest('.sects');
        if(section.hasClass('user')){
            alertitle = "계약자 정보 변경";
            alertmsg = "계약자 및 실사용자 정보 변경을 위해 고객님의 본인인증이 필요합니다. 진행하시겠습니까 ?";
            sendata = {confirmType: MODE_USER}
        } else{
			if (fnKakaoSubscribeOnCheck('changePaymentBtn')) return; // BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 ADD
            alertitle = "납부정보 변경";
            alertmsg = "납부정보 변경을 위해 고객님의 본인인증이 필요합니다. 진행하시겠습니까 ?";
            sendata = {confirmType: MODE_PAYMENT}
        }
        sendata["contractID"] = $('select[name=contractInfo]').find('option:selected').val();
        lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck(INFO_MODIFY_CONFIRM, sendata, function(result){
            // CSR-20063 NICE 통합인증 URL 발급 실패시 안내
            if (!result.data || result.data.success !== "Y" || !result.data.authUrl) {
                // CSR-20063 운영 장애 분석용 - 인증 URL 발급 실패 로그
                lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck("/my-page/care-solution-contract-status/errorLog.lgajax", {errType: "NICE_INTC_AUTH_URL_FAIL", status: result.status, message: result.message, page: location.pathname}, null, "POST");
                lgkorUI.alert("", {
                    title: result.message || "본인인증 요청에 실패했습니다."
                });
                return;
            }
            lgkorUI.confirm(alertmsg, {
                title: alertitle,
                cancelBtnName: "취소",
                okBtnName: "본인인증",
                ok: function(){
                    // CSR-20063 NICE 통합인증 - 앱에서 외부 브라우저로 열리지 않도록 빈 팝업을 먼저 열고 인증 URL로 이동
                    var nicePopup = window.open("", "popupChk", "width=480, height=812, scrollbars=yes, location=no, menubar=no, status=no, toolbar=no");
                    // CSR-20063 화면이 새로고침(비로그인 재로그인 등)되면 빈 팝업도 닫기
                    $(window).one('beforeunload pagehide', function(){ if (nicePopup && !nicePopup.closed) { nicePopup.close(); } });
                    // CSR-20063 NICE 통합인증 표준창 호출 (이미 열린 popupChk 창을 이름으로 찾아 이동)
                    var authPopup = window.open(result.data.authUrl, "popupChk", "width=480, height=812, scrollbars=yes, location=no, menubar=no, status=no, toolbar=no");
                    // CSR-20063 운영 장애 분석용 - 팝업 차단 등으로 표준창이 열리지 않은 경우 로그
                    if (!authPopup) { lgkorUI.requestAjaxDataIgnoreCommonSuccessCheck("/my-page/care-solution-contract-status/errorLog.lgajax", {errType: "NICE_INTC_POPUP_OPEN_FAIL", page: location.pathname}, null, "POST"); }

                    // editBasicInfomation();
                    //editPaymentInfomation();
                }
            }, item); // BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리
        }, ajaxMethod);
    }

    //나이스 콜백 -정보변경
    function editBasicInfomation(){
        userInfoBlock.hide();
        if(custGb == "O"){
            //사업자 정보 비노출
            $('label[for=company]').parent().parent().show();
            $('label[for=rprNm]').parent().parent().show();
            $('label[for=bsnRgsNmb]').parent().parent().show();
            $('label[for=companyAdress]').parent().parent().show();
            $('label[for=userAdress]').parent().parent().hide();
        }else{
            //사업자 정보 비노출
            $('label[for=company]').parent().parent().hide();
            $('label[for=rprNm]').parent().parent().hide();
            $('label[for=bsnRgsNmb]').parent().parent().hide();
            $('label[for=companyAdress]').parent().parent().hide();
            $('label[for=userAdress]').parent().parent().show();
        }
        
        userModifyBlock.show();
    }
    //나이스 콜백 -납부정보변경
    function editPaymentInfomation(){
        paymentInfoBlock.hide();
        if(custGb == "O"){
            $('#businessBankText').show();
            $('#businessCardText').show();
        }else{
            $('#businessBankText').hide();
            $('#businessCardText').hide();
        }
        paymentModifyBlock.show();
        paymentModifyBlock.find('input[name=selfClearingAgree]').prop('checked', false);
        $('#sel-date').val(transDay+"일");
        if($('input:radio[name= method-pay]:checked').val() == "card"){
            $('input[name=paymentCardNumber]').focusout();
            $('input[name=paymentCardPeriod]').focusout();
            $('#cardMsg').show();
            $('#ipt-bank1').data('realData','');
            $('#ipt-bank2').data('realData','');
            $('input[name=orgPaymentBank]').val('');
            $('input[name=orgPaymentBankNumber]').val('');
        }else{
            $('input[name=paymentBankNumber]').focusout();
            $('#bankMsg').show();
            $('#ipt-card1').data('realData','');
            $('#ipt-card2').data('realData','');
            $('input[name=orgPaymentCardNumber]').val('');
            $('input[name=orgPaymentCardPeriod]').val('');
        }
        
        $('#arsAgreeMsg').hide();
        $('#agreeErrMsg').hide();
        $('#arsMsg').hide();
        $('#arsAgreeCheck').hide();

        
        
        
        
        //결제변경 화면 진입시 초기설정 변경
        $('#arsAgreeRequest').attr('disabled', true);
        $('input[name=selfClearingAgree]').attr('disabled', true);
        $('#paymentBtn').attr('disabled', true);

        //카드/계좌 납부 확인 버튼
        $('#cardConfirm').attr('disabled', true);
        $('#bankConfirm').attr('disabled', true);
        
        //하단문구
        $('#arsAgreeCheckMsg').show();
        
        //정기 출금일 초기화
        
        $('input[name=changeBtn]').prop('checked', false);
        $('input[name=mpaymentDate]').prop('checked', false);
        $('#payDay').hide();
        $('#payMsg').hide();
        $('#inputPayDat').show();
        $('#sel-date').val(transDay);
        transDayChangeYN = "N";
        paymentDate = "";
        
        setHiddenData('paymentMethodConfirm', "N");
        setHiddenData('arsAgree', "N");
    }
    //나이스 콜백 -인증실패
    function fnNiceFail(msg){
        if(msg){
            lgkorUI.alert("", {
                title: msg
            })
        }
    }
    window.editBasicInfomation = editBasicInfomation;
    window.editPaymentInfomation = editPaymentInfomation;
    window.fnNiceFail = fnNiceFail;

    //사용자 정보변경 취소...
    function saveUserInfoCancel(){
        userInfoValidation.setValues(userInfo);
        userModifyBlock.find('.err-block').hide();
        userModifyBlock.hide();
        userInfoBlock.show();
    }
    //사용자 정보변경 저장...
    function saveUserInfoOk(){
        var result = userInfoValidation.validate();
        if(!result.success) return;

        lgkorUI.showLoading();

        var sendata = userInfoValidation.getAllValues();
        sendata.confirmType = MODE_USER;
        sendata.contractID = $('select[name=contractInfo]').find('option:selected').val();
        sendata.custGb = custGb;
        lgkorUI.requestAjaxData(INFO_MODIFY_SAVE, sendata, function(result){
            if(lgkorUI.stringToBool(result.data.success)){
                changeContractInfo();
            }

            lgkorUI.hideLoading();
        }, ajaxMethod);
    }

    //제휴카드 신청
    function setRequestCard(){
    	
    	// BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 START
    	var alertitle		= "제휴카드 발급 신청";
    	var alertmsg		= "";
    	
    	if(associCardType) {
        	if (associCardStatus == "Y") { // 제휴카드신청현황 BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 [D:고객정보 다름 / Y : 발급성공 / E : 발급실패 / R : 카드사신청완료 / N : 카드사신청이전]
        		
        		// Y : 발급성공
        		if (careApplyCardCnt > 0) { // 신청내역 있음
        			lgkorUI.alert("", {
                        title: "이미 제휴카드를 이용 중이므로 \n온라인으로 신청할 수 없습니다.\n고객센터로 문의 바랍니다."
                    });
                    return;
        		} else {
                    alertmsg = "이미 제휴카드를 이용 중입니다.\n다른 카드를 신청하시겠습니까?";
                    
                    lgkorUI.confirm(alertmsg, {
                        title: alertitle,
                        cancelBtnName: "취소",
                        okBtnName: "확인",
                        ok: function(){
                        	var contractInfoText = $('select[name=contractInfo]').find('option:selected').text();
                            $('#popup-cardIssue').find('input[name=reqcard-contractInfo]').val(contractInfoText);
                            $('#popup-cardIssue').vcModal({opener:$('.mypage .requestCard-btn')})
                            .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
                        }
                    });
        		}
        	} else if (associCardStatus == "N" || associCardStatus == "R") {
        		
        		// N : 카드사신청이전 / R : 카드사신청완료
        		$(window).trigger("toastshow", "이미 신청된 상태입니다.");
        	} else if (associCardStatus == "E") {
        		
        		// E : 발급실패
        		if (careApplyCardCnt > 0) { // 신청내역 있음
        			lgkorUI.alert("", {
                        title: "신청했던 제휴카드가 정상적으로 발급되지 않았습니다.\n고객센터로 문의 바랍니다."
                    });
                    return;
        		} else {
        			var contractInfoText = $('select[name=contractInfo]').find('option:selected').text();
                    $('#popup-cardIssue').find('input[name=reqcard-contractInfo]').val(contractInfoText);
                    $('#popup-cardIssue').vcModal({opener:$('.mypage .requestCard-btn')})
                    .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
        		}
        	}
        } else {
        	// 신청내역 없음
        	if (careApplyCardCnt > 0) {
    			
        		$(window).trigger("toastshow", "이미 신청된 상태입니다.");
        		return;
        	}
    		
    		var contractInfoText = $('select[name=contractInfo]').find('option:selected').text();
            $('#popup-cardIssue').find('input[name=reqcard-contractInfo]').val(contractInfoText);
            $('#popup-cardIssue').vcModal({opener:$('.mypage .requestCard-btn')})
            .off('modalshown').on('modalshown', toggleAppBottomMenu); // BTOCSITE-18946 하단탭바 미노출 처리
        }
    	// BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 END    
    }

    //제휴카드 
    function setIssueCardList(data){
        var select = $('#popup-cardIssue').find('select[name=concertedCard]');
        select.empty();
        select.append('<option value="" class="placeholder">선택</option>');
        for(var idx in data){
            var opt = "<option value='" + data[idx].cardValue + "'>" + data[idx].cardName + "</option>";
            select.append(opt);
        }
        select.vcSelectbox('update');
    }

    //제휴카드 발급신청
    function requestCardIssue(){
        var val = $('#popup-cardIssue').find('input[name=cardIssueAllchker_1]').prop('checked');
        if(!val){
            lgkorUI.alert("", {
                title: "개인정보 수집/이용 동의해주세요."
            });
            return;
        }

        val = $('#popup-cardIssue').find('input[name=cardIssueAllchker_2]').prop('checked');
        if(!val){
            lgkorUI.alert("", {
                title: "개인정보 제3자 제공 동의 해주세요."
            });
            return;
        }

        val = $('#popup-cardIssue').find('select[name=concertedCard]').find('option:selected').val();
        if(!val){
            lgkorUI.alert("", {
                title: "제휴카드를 선택하세요."
            });
            return;
        }

        lgkorUI.showLoading();

        var sendata = {
            contractID: $('select[name=contractInfo]').find('option:selected').val(),
            selectCardValue: val
        }
        lgkorUI.requestAjaxData(REQUSET_CARD_URL, sendata, function(result){
            $('#popup-cardIssue').vcModal('close');

            lgkorUI.hideLoading();

            if(result.status == "success"){ 
        		careApplyCardCnt++; // 제휴카드 신청 현황(DB) BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 add
        		$(window).trigger("toastshow", "신청이 완료되었습니다.");
            } else { // fail
            	$(window).trigger("toastshow", "신청이 실패하였습니다. 다시 시도해주세요.");
            }	
        }, ajaxMethod);
    }

    //납부정보 input 밸리데이션...
    function paymentFieldValidation(){
        var paymentMethodIndex = $('.mypage .section-wrap .sects.payment.new-form-style input[name=method-pay]:checked').data("visibleTarget") == ".by-bank";
        var result = paymentMethodIndex ? bankValidation.validate() : cardValidation.validate();
        
        return result.success;
    }
    //납부정보 입력 데이터 비교...
    function compareInputData(){
        var paymentMethodIndex = $('.mypage .section-wrap .sects.payment.new-form-style input[name=method-pay]:checked').data("visibleTarget") == ".by-bank";
        var values;
        if(paymentMethodIndex){
            values = bankValidation.getAllValues();
            values.paymentUserName = $('#ipt-bank1').data('realData');
            values.paymentBankNumber = $('#ipt-bank2').data('realData');
        }else{
            values = cardValidation.getAllValues();
            values.paymentCardNumber = $('#ipt-card1').data('realData');
            values.paymentCardPeriod = $('#ipt-card2').data('realData');
        }
        var chk = true;
        for(var str in values){
            if(paymentInfo[str] !== values[str]){
                chk = false;

                break;
            }
        }
        //정기출금일 변경

        return chk;
    }
    //납부정보 확인 유무...
    function paymentConfirmYN(){
        var paymentMethodAbled = getHiddenData("paymentMethodConfirm");
        if(paymentMethodAbled == "N"){
            paymentErrorAlert();
            return false;
        }

        return true;
    }
    //납부 확인 오류창...
    function paymentErrorAlert(){
        var paymentMethodIndex = $('.mypage .section-wrap .sects.payment.new-form-style input[name=method-pay]:checked').data("visibleTarget") == ".by-bank";
        lgkorUI.alert("",{
            title: paymentMethodIndex ? "납부 계좌 확인이 필요합니다." : "납부 카드 확인이 필요합니다."
        });
        setHiddenData('arsAgree', "N");
    }
    //납부카드/계좌 확인...
    function setPaymentMethodAbled(item){
        var chk = paymentFieldValidation();
        if(!chk) return false;

        paymentInfo = {};
        //BTOCSITE-18356 start
        var userPhone = userInfo.userPhone;
        var actualUserPhone = userInfo.actualUserPhone;
        //BTOCSITE-18356 END
        CERTI_ID = BATCH_KEY = "";

        var sendata;
        if($(item).hasClass('paymentCardConfirm')){
            sendata = cardValidation.getAllValues();
            sendata.paymentCardNumber = $('#ipt-card1').data('realData');
            sendata.paymentCardPeriod = $('#ipt-card2').data('realData');
                
            sendata.confirmType = METHOD_CARD;
        } else{
            sendata = bankValidation.getAllValues();
            sendata.paymentUserName = $('#ipt-bank1').data('realData');
            sendata.paymentBankNumber = $('#ipt-bank2').data('realData');
            sendata.confirmType = METHOD_BANK;
            //BTOCSITE-18356 start
            var paymentBankNumberTxt = $('input[name=paymentBankNumber]').val(); 
            if(userPhone==paymentBankNumberTxt||actualUserPhone==paymentBankNumberTxt){
            	lgkorUI.alert('', {
                    title: "유효하지 않거나, 잘못된 계좌 정보입니다.<br>다시 확인해 주세요."
                });
            	
            	return;
            }
            //BTOCSITE-18356 END
        }
        sendata.contractID = $('select[name=contractInfo]').find('option:selected').val()
        lgkorUI.requestAjaxData(PAYMENT_METHOD_CONFIRM, sendata, function(result){
            lgkorUI.alert(result.data.alert.desc, {
                title: result.data.alert.title
            });

            if(result.data.CERTI_ID) CERTI_ID = result.data.CERTI_ID;
            if(result.data.BATCH_KEY) BATCH_KEY = result.data.BATCH_KEY;

            if(lgkorUI.stringToBool(result.data.success)){
                if(sendata.confirmType == METHOD_CARD){ 
                    paymentInfo = cardValidation.getAllValues();
                    paymentInfo.paymentCardNumber = $('#ipt-card1').data('realData');
                    paymentInfo.paymentCardPeriod = $('#ipt-card2').data('realData');
                    $('#ipt-bank1').data('realData','');
                    $('#ipt-bank2').data('realData','');
                    $('#ipt-bank2').val('');
                    $('input[name=orgPaymentBank]').val('');
                    $('input[name=orgPaymentBankNumber]').val('');
                    $('select[name=paymentBank] option').eq(0).prop('selected', true);
                    $('select[name=paymentBank]').vcSelectbox('update');
                } else{
                    paymentInfo = bankValidation.getAllValues();
                    paymentInfo.paymentUserName = $('#ipt-bank1').data('realData');
                    paymentInfo.paymentBankNumber = $('#ipt-bank2').data('realData');
                    $('#ipt-card1').data('realData','');
                    $('#ipt-card2').data('realData','');
                    $('#ipt-card1').val('');
                    $('#ipt-card2').val('');
                    $('input[name=orgPaymentCardNumber]').val('');
                    $('input[name=orgPaymentCardPeriod]').val('');
                    $('select[name=paymentCard] option').eq(0).prop('selected', true)
                    $('select[name=paymentBank]').vcSelectbox('update');

                }
                paymentInfo.confirmType = sendata.confirmType;
            }
            
            if(result.data.success == "Y"){
                $('#arsAgreeRequest').attr('disabled', false);
                $('input[name=selfClearingAgree]').attr('disabled', false);
                $('#paymentBtn').attr('disabled', false);
                
                if(sendata.confirmType == METHOD_CARD){
                    $('#cardMsg').show();
                    $('#cardConfirm').attr('disabled', true);
                }else{
                    $('#bankMsg').show();
                    $('#bankConfirm').attr('disabled', true);
                }
                
            }

            sendPaymentMethod = sendata.confirmType;

            setHiddenData('paymentMethodConfirm', result.data.success);

            /* BTOSCITE-98 add */
            if (vcui.detect.isIOS){
                setHiddenData('arsAgree', "N");
                arsAgreeConfirm = "N";
                $('#arsAgreeRequestCheck').show();
                $('#arsAgreeRequestCheck').attr('disabled', true);
            }
            /* //BTOSCITE-98 add */


        }, ajaxMethod);
    }
    //환불계좌 확인 오류창
    function refundErrorAlert(){
        // [S] BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리
        lgkorUI.alert("",{
            title: "계좌 확인이 필요합니다."
        }, (function(){
            var focusTarget = '';
            $('.refund-bank.modify').each(function() {
                var $this = $(this);
                var $targetBtn = $this.find('.box .cell .btn');

                if ($targetBtn.is(':disabled')){
                    focusTarget = $this.find('.box .input-wrap input')[0];
                } else {
                    focusTarget = $targetBtn[0];
                }
            });

            return focusTarget;
        })());
        // [E] BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리
    }

    //환불계좌 input 밸리데이션...
    function refundFieldValidation(){
        var result = refundValidation.validate();
        
        return result.success;
    }

    //환불계좌 확인 유무
    function refundConfirmYN(){
        var refundMethodAbled = getHiddenData("paymentMethodConfirm");
        if(refundMethodAbled == "N"){
            refundErrorAlert();
            return false;
        }

        return true;
    }

    //환불계좌 유효성 체크
    function refundInfoValidation(){
        var chk = refundConfirmYN();
        if(!chk) return false;

        chk = refundCompareInputData();
        if(!chk){
            refundErrorAlert();
            return false;
        }

        return true;
    }

    //환불계좌 입력 데이터 비교
    function refundCompareInputData(){
        var values = refundValidation.getAllValues();
        var chk = true;
        for(var str in values){
            if(refundInfo[str] !== values[str]){
                chk = false;

                break;
            }
        }

        return chk;
    }


    //환불계좌 확인
    function setRefundMethodAbled(item){
        var chk = refundFieldValidation();
        if(!chk) return false;
        
        paymentInfo = {};

        var userPhone = userInfo.userPhone;
        var actualUserPhone = userInfo.actualUserPhone;

        CERTI_ID = BATCH_KEY = "";

        var sendata;
        sendata = refundValidation.getValues();
        // sendata.bankAccount = $('input[name=bankAccount]').val();
        // sendata.bankCd = $('input[name=bankCd]').val();
        var bankCdTxt = $('input[name=bankAccount]').val(); 
            if(userPhone==bankCdTxt||actualUserPhone==bankCdTxt){
                lgkorUI.alert('', {
                    title: "유효하지 않거나, 잘못된 계좌 정보입니다.<br>다시 확인해 주세요."
                },$('.form-wrap .forms .btn'));
                
                return;
            }
            sendata.contractID = $('select[name=contractInfo]').find('option:selected').val();
        lgkorUI.requestAjaxData(BANK_ACCOUNT_URL, sendata, function(result){
            lgkorUI.alert('', {
                title: "계좌 정보가 정상적으로 확인되었습니다.",
                
            },$('.form-wrap .forms .btn'));

            if(result.data.SEQ) REFUND_REQ = result.data.SEQ;
            if(lgkorUI.stringToBool(result.data.success)){
                refundInfo = refundValidation.getAllValues();
                // refundInfo.confirmType = sendata.confirmType;
            }

            setHiddenData('paymentMethodConfirm', result.data.success);

        }, ajaxMethod);
    }

    // 환불계좌 저장...
    function saveRefundInfoOk(){
        var chk = refundInfoValidation();
        if(chk){
            // lgkorUI.showLoading();

            var sendata = {
                // contLineSeq: $('select[name=contractInfo]').find('option:selected').val(), //계약번호
                contLineSeq: refundSaveContractID, //계약번호
                refundBankCode: $('select[name=bankCd]').find('option:selected').val(),  //은행코드
                refundAccountNum: $('input[name=bankAccount]').val(),  //은행계좌
                refundAccountCertSeq: REFUND_REQ  //계좌확인 seq
            }
            for(var key in paymentInfo) sendata[key] = paymentInfo[key];
            
            lgkorUI.requestAjaxData(REFUND_ACCOUNT_SAVE_URL, sendata, function(result){
                if(result.status == 'success'){
                    $('.btn.border.size.refund-bank.button').prop('disabled', false);
                    changeContractInfo();
                }

                // lgkorUI.hideLoading();
            }, ajaxMethod);
        } 
    }

    //ARS출금동의 신청...
    var arsCallingInterval = null;
    var iosAgreeCallCheck = false;
    function setArsAgreeConfirm(){
        /* BTOCSITE-98 add */
        if (vcui.detect.isIOS){
            lgkorUI.showLoading();
        }

        isClickedarsAgreeConfirmBtn = true;
        $('#arsAgreeRequest').attr('disabled', true);
        clearTimeout(arsCallingInterval);
        arsCallingInterval = setTimeout(function(){
            $('#arsAgreeRequest').attr('disabled', false);
            if (vcui.detect.isIOS){
                lgkorUI.hideLoading();
            }
        }, 5000);
        /* //BTOCSITE-98 add */

        var chk = paymentConfirmYN();
        if(!chk) return;

        chk = compareInputData();
        if(!chk){
            paymentErrorAlert();
            return;
        }

        lgkorUI.showLoading();
        
        CTI_REQUEST_KEY = "";

        var sendata = sendPaymentMethod == METHOD_CARD ? cardValidation.getValues() : bankValidation.getValues();
        if(sendPaymentMethod == METHOD_CARD){
            sendata = cardValidation.getValues();
            sendata.paymentCardNumber = $('#ipt-card1').data('realData');
            sendata.paymentCardPeriod = $('#ipt-card2').data('realData');
        } else{
            sendata = bankValidation.getValues();
            sendata.paymentUserName = $('#ipt-bank1').data('realData');
            sendata.paymentBankNumber = $('#ipt-bank2').data('realData');
        }
        sendata.contractID = $('select[name=contractInfo]').find('option:selected').val();
        sendata.confirmType = sendPaymentMethod;

        setHiddenData('arsAgree', "N");

        // BTOCSITE-98 add
        if (vcui.detect.isIOS){
            $('#arsAgreeRequestCheck').attr('disabled', false);            
            arsAgreeConfirm = "N";
            //CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;
        } else {
            //CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;                    
        }
        /*
        lgkorUI.requestAjaxDataAddTimeout(ARS_AGREE_URL, 180000, sendata, function(result){
            lgkorUI.alert(result.data.alert.desc, {
                title: result.data.alert.title
            });

            CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;

            setHiddenData('arsAgree', result.data.success);
        }, ajaxMethod, null, true);
        */
        if(vcui.detect.isIOS) {
            if(!iosAgreeCallCheck ) {
                iosAgreeCallCheck = true;
                setTimeout(function (){
                    $.ajax({
                        method : ajaxMethod,
                        url : ARS_AGREE_URL,
                        data : sendata,
                        async : false,
                        success : function(result){         
                            if (!vcui.detect.isIOS){
                                lgkorUI.alert(result.data.alert.desc, {
                                    title: result.data.alert.title
                                });
                            }
            
                            // BTOCSITE-98 add
                            if (vcui.detect.isIOS){
                                //$('.arsAgreeRequestCheck').attr('disabled', false);
                                CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;
                            } else {
                                CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;                    
                            }
                            
                            setHiddenData('arsAgree', result.data.success); 
                            if(result.data.success == "Y"){
                                $('#arsAgreeRequest').attr('disabled', true);
                                $('#arsAgreeRequestCheck').attr('disabled', false).show();
                                $('#iostxt').show();
                                $('#arsMsg').hide();
                            }
                            // //BTOCSITE-98 add
                            iosAgreeCallCheck = false;
                        },
                        error : function(error){
                            //alert('error');
                            iosAgreeCallCheck = false;
                        },
                        complete : function(){
                            //alert('complete');
                            lgkorUI.hideLoading();
                            iosAgreeCallCheck = false;
                        }
                    });
                },1000);
            }
        } else {
			if(vcui.detect.isApp ) {
                android.notifyAppWillPause();
			}
			
			var arsAgreeCheckInterval = setInterval(function(){
                $.ajax({
                    url:ARS_AGREE_CHECK_URL,
                    method : ajaxMethod,
                    async : false,
                    success : function(result){
                        arsAgreeConfirm = result.data.success;

                        var isSuccess = lgkorUI.stringToBool(result.data.success);
                        var arsAgreeCheckStopFlag = result.data.arsAgreeCheckStopFlag;    // ACS로부터 성공/실패 응답받는 경우, arsAgreeCheckStopFlag = 'Y'로 SET
                        if(isSuccess || arsAgreeCheckStopFlag == 'Y') {
                            clearInterval(arsAgreeCheckInterval);

                            lgkorUI.alert(result.data.alert.desc, {
                                title: result.data.alert.title
                            });

                            if(isSuccess) {
                                CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;
                                setHiddenData('arsAgree', arsAgreeConfirm);
                                clearInterval(arsAgreeCheckInterval);
                                //오류 문구 제거
                                $('#arsMsg').hide();
                                $('#arsAgreeCheck').show();
                                $('#arsAgreeCheckMsg').hide();
                                $('#agreeErrMsg').hide();
                                $('#arsAgreeRequest').attr('disabled', true);
                            }else {
                                $('#agreeErrMsg').show();
                                $('#arsAgreeCheckMsg').show();
                                $('#arsAgreeCheck').hide();
                                $('#arsMsg').hide();
                                setHiddenData('arsAgree', "N");
                            }
                        }

                    },
                    error : function(error){
                        clearInterval(arsAgreeCheckInterval);
                    },
                    complete : function(){
                        lgkorUI.hideLoading();
                    }
                });
            }, 1000);
            
            $.ajax({
                method : ajaxMethod,
                url : ARS_AGREE_URL,
                data : sendata,
                async : true,
                timeout : 2000,  // BTOCSITE-59557 청약시 ARS 출금동의 중복 확인 요청
                success : function(result){         
                    lgkorUI.alert(result.data.alert.desc, {
                        title: result.data.alert.title
                    });
    
                    CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;    
                    setHiddenData('arsAgree', result.data.success);
                },
                error : function(error){
                    //alert('error');
                },
                complete : function(){
                    //alert('complete');
                    lgkorUI.hideLoading();
                }
            });
        }
    }
    // ARS 출금동의요청 체크 :: BTOCSITE-98 add
    var arsConfirmCallingInterval = null;
    function arsAgreeConfirmCheck(){
        isClickedarsAgreeConfirmCheckBtn = true;
        $('#arsAgreeRequestCheck').attr('disabled', true);
        clearTimeout(arsConfirmCallingInterval);
        arsConfirmCallingInterval = setTimeout(function(){
            $('#arsAgreeRequestCheck').attr('disabled', false);
        }, 3000);

        lgkorUI.showLoading();

        //CTI_REQUEST_KEY = "";
        arsAgreeConfirm = "N";

        lgkorUI.requestAjaxDataAddTimeout(ARS_AGREE_CHECK_URL, 180000, {}, function(result){
            //console.log('출금동의요청 체크 결과', result);
            lgkorUI.alert(result.data.alert.desc, {
                title: result.data.alert.title
            });

            CTI_REQUEST_KEY = result.data.CTI_REQUEST_KEY;
            arsAgreeConfirm = result.data.success;

            if (arsAgreeConfirm !== "Y"){
                setHiddenData('arsAgree' , 'N');
                $('#agreeErrMsg').show();
            }else{
                $('#arsAgreeCheck').show();
                $('#arsAgreeRequestCheck').attr('disabled', true).hide();
                $('#arsAgreeRequest').attr('disabled', true);
                $('#agreeErrMsg').hide();
                $('#arsAgreeMsg').hide();
                $('#arsAgreeCheckMsg').hide();
            }
            
        }, ajaxMethod, null, true);
        
    }

    //납부 정보변경 취소...
    function savePaymentInfoCancel(){
        try{
            cardValidation.setValues(cardInfo);
            //$('.ui_card_number').vcFormatter('update');
    
            bankValidation.setValues(bankInfo);
            setHiddenData('paymentMethodConfirm', "N");
            setHiddenData('arsAgree', "N");
            paymentModifyBlock.find('input[name=selfClearingAgree]').prop('checked', false);
            paymentModifyBlock.find('input[name=pointUseAgree]').prop('checked', false);
    
            setPaymentModeCont();
    
            paymentInfoBlock.show();
            paymentModifyBlock.hide();
        } catch(err){
            console.log(err);
        }
    }
    //변경사항 여부 체크
    function changeChk(){
        if($('input:radio[name= method-pay]:checked').val() == "card"){
            if($('#ipt-card1').data('realData') == $('input[name=orgPaymentCardNumber]').val() 
                && $('#ipt-card2').data('realData') == $('input[name=orgPaymentCardPeriod]').val()
                && $("select[name=paymentCard]").val() == $('input[name=orgPaymentCard]').val() ){
                return false;
            }
        }else{
            if($('#ipt-bank1').data('realData') == $('input[name=orgPaymentUserName]').val()
                && $('#ipt-bank2').data('realData') == $('input[name=orgPaymentBankNumber]').val()
                && $("select[name=paymentBank]").val() == $('input[name=orgPaymentBank]').val() ){
                return false;
            }
        }
        return true;
    }

    //납부 정보변경 저장...
    function savePaymentInfoOk(){
        if(getHiddenData('paymentMethodConfirm') == "Y"){
            var chk = paymentInfoValidation();

            if(!chk){
                return false;
            }    
        }
        
        if(getHiddenData('paymentMethodConfirm') == "N"){
            if($('input:radio[name= method-pay]:checked').val() == "card"){
                paymentInfo = cardValidation.getAllValues();
                paymentInfo.paymentCardNumber = $('#ipt-card1').data('realData');
                paymentInfo.paymentCardPeriod = $('#ipt-card2').data('realData');
            } else{
                paymentInfo = bankValidation.getAllValues();
                paymentInfo.paymentUserName = $('#ipt-bank1').data('realData');
                paymentInfo.paymentBankNumber = $('#ipt-bank2').data('realData');
            }
        }
        
        if(transDayChangeYN == "Y"){
            if(paymentDate == "" || paymentDate == null){
                $('#payMsg').show();
                lgkorUI.alert("", {
                    title: "정기 출금일 선택을 완료해 주세요."
                });
                return;
            }else{
                $('#payMsg').hide();
            }
        }
        paymentInfo.transDayChangeYN = transDayChangeYN;
        paymentInfo.paymentDate = paymentDate;
        paymentInfo.paymentMethodConfirm = getHiddenData('paymentMethodConfirm');
        paymentInfo.custGb = custGb;
        paymentInfo.bsnRgsNmb = bsnRgsNmb;
        paymentInfo.company = company
        lgkorUI.showLoading();

        var sendata = {
            contractID: $('select[name=contractInfo]').find('option:selected').val(),
            CERTI_ID: CERTI_ID,
            BATCH_KEY: BATCH_KEY,
            CTI_REQUEST_KEY: CTI_REQUEST_KEY
        }
        for(var key in paymentInfo) sendata[key] = paymentInfo[key];
        
        lgkorUI.requestAjaxData(PAYMENT_SAVE_URL, sendata, function(result){

            lgkorUI.alert("", {
                title: result.data.alert
            });
            if(lgkorUI.stringToBool(result.data.success)){
                changeContractInfo();
            }

            lgkorUI.hideLoading();
        }, ajaxMethod);
    }

    //납부 정보 유효성 체크
    function paymentInfoValidation(){
        var chk = paymentConfirmYN();
        if(!chk) return false;

        chk = compareInputData();
        if(!chk){
            paymentErrorAlert();
            return false;
        }
        
        //에러 문구 노출
        //변경이 없을경우 alert처리 해야함
        if(getHiddenData('paymentMethodConfirm') == "Y" && !changeChk()){
            lgkorUI.alert("", {
                title: "납부 정보 변경 내용이 없습니다."
            });
            return false;
        }

        if(getHiddenData("arsAgree") !== "Y" && !vcui.detect.isIOS){
            $('#arsAgreeMsg').hide();
            $('#agreeErrMsg').hide();
            $('#arsMsg').show();
            lgkorUI.alert("",{
                title: "자동결제를 위해 ARS 출금동의 신청해주세요."
            });

            return false;
        }
        

        /* BTOCSITE-98 add */
        if(arsAgreeConfirm !== "Y" && vcui.detect.isIOS){

            if (getHiddenData("arsAgree") !== "Y"){
                lgkorUI.alert("",{
                    title: "자동결제를 위해 ARS 출금동의 신청해주세요"
                });
                
                $('#agreeErrMsg').hide();
                $('#arsAgreeMsg').hide();
                $('#arsMsg').show();
                return false;
            }

            if (arsAgreeConfirm !== "Y"){
                $('#iostxt').show();
                $('#arsAgreeMsg').show();
                $('#agreeErrMsg').hide();
                $('#arsMsg').hide();
                lgkorUI.alert("",{
                    title: "자동결제를 위해 ARS 출금동의 확인 버튼을 클릭해 주세요"
                });
                return false;
            }
            
        }
        /* //BTOCSITE-98 add */

        if(!paymentModifyBlock.find('input[name=selfClearingAgree]').prop('checked')){
            $('#agreeMsg').show();
            $('#arsAgreeMsg').hide();
            $('#agreeErrMsg').hide();
            $('#arsMsg').hide();
            lgkorUI.alert("",{
                title: "자동결제를 위해 정기결제 신청을 동의해주세요."
            });
            return false;
        }
        
        return true;
    }

    function showMempointModify(){
    	
    	if (fnKakaoSubscribeOnCheck('mempointBtn')) return; // BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 ADD
        
    	$('.mempoint-btn').prop('disabled', true);

        $('.mempoint-info').find('input[name=point-cancel]').prop('checked', true);

        $('.mempoint-info .viewer').hide();

        $('.mempoint-info .modify').show();
        $('.mempoint-info .btn-group').show();
    }
    function cancelMempointModify(isBtn){
        $('.mempoint-btn').prop('disabled', false);
        //취소버튼 클릭시 focus 이동
        if(isBtn){
            $('.mempoint-btn').focus(); // BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리    
        }
        

        $('.mempoint-info .viewer').show();

        $('.mempoint-info .modify').hide();
        $('.mempoint-info .btn-group').hide();
    }
    //멤버십 포인트 차감동의 저장
    function okMempointModify(){
        var sendata = {
            isAgree: $('.mempoint-info').data('isAgree'),
            deductType: $('.mempoint-info').data('deductType'),
            userPoint: $('.mempoint-info').data('userPoint'),
            deductPoint: $('.mempoint-info').data('deductPoint'),
            contractID: $('select[name=contractInfo]').find('option:selected').val()
        }
        
        if(sendata.isAgree){
            var chk = $('.mempoint-info').find('input[name=point-cancel]').prop('checked');
            sendata.isAgree = !chk;
            sendata.deductPoint = '';
        } else{
            // BTOCSITE-64440 [청약-2차 개선] 멤버십 포인트 차감 기능 개선의 건 (서비스구독 신청페이지)
            sendata.deductType = '';
            sendata.deductPoint = $('.mempoint-info').find('select[name=membershipPoint] option:selected').val();

            if(sendata.deductPoint == undefined || sendata.deductPoint == null || sendata.deductPoint == '0'){
                lgkorUI.alert("", {title:"사용 포인트를 선택해 주세요."}, '.mempoint-info .point-box .ui-select-button'); // BTOCSITE-77523 [웹앱 접근성 개선활동] 주문/청약_마이페이지_구독관리
                return;
            }
            // [BTOCSITE-70119] 멤버십 포인트 차감 기능 개선 ("전체" 옵션 추가)
            if(sendata.deductPoint == 'all'){
                sendata.deductType = 'all';
            }
            sendata.isAgree = true;
        }
        
        lgkorUI.showLoading();

        lgkorUI.requestAjaxData(MEMPOINT_DEDUCT_URL, sendata, function(result){
            if(lgkorUI.stringToBool(result.data.success)){
                changeContractInfo();
            }

            lgkorUI.hideLoading();
        }, ajaxMethod);
    }

    function refundModify(){
        $('.btn.border.size.refund-bank.button').prop('disabled', true);

        $('.section-inner.refund-bank.viewer').hide();
        $('.sects.refund-bank-sects div.section-inner.type2.refund-bank.modify').show();
        $('.refund-bank-sects .btn-group').show();
        $('.form-wrap .forms .btn').prop('disabled', true);
        
        if($('#refund-bank3').val() == '') {
            $('.form-wrap .forms .btn').prop('disabled', true);
        }else{
            $('.form-wrap .forms .btn').prop('disabled', false);
        }
        
        $('#refund-bank3').on('input', function(){
            if($('#refund-bank3').val() == '') {
                $('.form-wrap .forms .btn').prop('disabled', true);
            }else{
                $('.form-wrap .forms .btn').prop('disabled', false);
            }

        })

    }
    
    function cancelRefundModify(){
        $('.btn.border.size.refund-bank.button').prop('disabled', false);

        $('.section-inner.refund-bank.viewer').show();
        $('.sects.refund-bank-sects div.section-inner.type2.refund-bank.modify').hide();
        $('.refund-bank-sects .btn-group').hide();
        $('.sects.refund-bank-sects .flt-cont button').focus();
    }

    function changeFieldValue(gname, data){
        for(var key in data){
            var keyData = data[key];
            if("user-info"===gname){
                if(!keyData){
                    $("."+gname).find('ul li[class=' + key + ']').hide();
                }else{
                    $("."+gname).find('ul li[class=' + key + ']').show();
                }
            }else if (gname == 'actual-info' && key == 'name'){
                var link = '/my-page/care-solution-contract-status/actualUserCounsel?contLineSeq=' + newgContractId;
                keyData = '<span>'+data[key]+'</span><a href=\"'+link+'\" class="btn-link">등록 상담 신청</a><a href="/my-page/inquiry-and-reservation-status" class="btn-link actualUserCounselInquiry-btn">신청 내역 조회</a>';
            } 
                $("."+gname).find('ul li[class=' + key + '] dd').empty().html(keyData);
        }
    }

    // 20210721 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
    function setContractInfo(data){
        mypage.find(".no-subscribe").remove();
        if(data != undefined && data != "" && data != null){
            var info;
            custGb = data.contractInfo.custGb;
            bsnRgsNmb = data.userInfo.user.bsnRgsNmb;
            company = data.userInfo.user.company;
            //BTOCSITE-64163 재구독
            if (data.contractInfo.reOrderUsableYN === 'Y' && data.contractInfo.custGb != 'O') {
                $('.re-subs-banner').show(); //subscribe-benefit
                var befor = "신청기간 : " + data.contractInfo.befor1Year + " 까지";
                $('.re-subs-banner .banner-link .banner-txt').text(befor);


            } else {
                $('.re-subs-banner').hide();
            }


            mypage.find(".section-wrap").show();
    
            info = getMaskingData(data.userInfo.user);
            changeFieldValue('user-info', info);
            
            
            ///BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 : 파라미터 값 보내는 버튼
            var clParm = data.contractInfo.contractID;
            newgContractId = clParm;
    
            info = getMaskingData(data.userInfo.actualUser);
            changeFieldValue('actual-info', info);
            //BTOCSITE-82295 사용자등록 상담요청 기능 개발
            if(data.contractInfo.acualUserRequestYn && data.contractInfo.acualUserRequestYn == "Y") {
				$(".actual-info").find('ul li[class=name] dd a.actualUserCounselInquiry-btn').show();
			}else{
				$(".actual-info").find('ul li[class=name] dd a.actualUserCounselInquiry-btn').hide();
			}

            info = getMaskingData(data.refundBankInfo);
            changeFieldValue('refund-bank-info', info);

			careApplyCardCnt = data.paymentInfo.careApplyCardCnt; // 제휴카드 신청 현황(DB) BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생 add
            

            if( $('.cl_listBtn > a').attr('data-current-href') == undefined) {
                $('.cl_listBtn > a').attr('data-current-href', $('.cl_listBtn > a').attr('href'))
            }
            $('.cl_listBtn > a').attr('href', $('.cl_listBtn > a').attr('data-current-href') + '?contractID=' + clParm);
            
            // 차세대 계약건일 경우 계약그룹번호 추가
            if (data.contractInfo.contGrpNo) {
                data.contractInfo.contractID = "<span>" + data.contractInfo.contractID + " (계약그룹번호: " + data.contractInfo.contGrpNo + ")" + "</span>";

            }else{
            data.contractInfo.contractID = "<span>" + data.contractInfo.contractID + "</span>";
            }

            //if(data.contractInfo.cancelRequestYn == "Y") data.contractInfo.contractID += "<a href='" + data.contractInfo.cancelResultUrl + "' class='btn-link cancelConsultInquiry-btn'>해지요청 조회</a>";
            // else data.contractInfo.contractID += "<a href='" + data.contractInfo.cancelConsultUrl + "' class='btn-link cancelConsult-btn'>해지상담 신청</a>";

            // BTOCSITE-22701 :: 구독서비스용 옵션 변경/옵션 확인 버튼 serviceName 값에 출력 되도록 변경
            // contractInfo.json 신규 추가 키값 (itemOptionType) : 'S' / 'F' / 'N' 출력 
            // ITEM_OPTION_TYPE 컬럼값이, 'S'면 옵션 변경하기 버튼 노출 / 'F,N'이면 옵션 확인하기 버튼 노출
            // if(data.contractInfo.itemOptionType == "" || data.contractInfo.itemOptionType == "F" || data.contractInfo.itemOptionType == "N") { // 옵션 확인하기
            //     data.contractInfo.serviceName += "<a href='#' class='btn-link selectOption-btn'>옵션 확인</a>"; //<!-- 221214 수정 : 텍스트 변경 -->
            // } else { //옵션 변경하기
            //     data.contractInfo.serviceName += "<a href='#' class='btn-link selectOption-btn'>옵션 확인 및 변경</a>"; //<!-- 221214 수정 : 텍스트 변경 -->
            // }
            
            
            // BTOCSITE-175 케어솔루션 > 무상케어십 정보 추가 노출 요청            
            // contractType - R :케어솔루션 C : 케어십 
            // contDtlType - C00 : 무상케어십
            // 무상케어십일때 해지상담 신청 버튼 비노출 
            if(data.contractInfo.contDtlType != 'C00'){
                data.contractInfo.contractID += "<a href='" + data.contractInfo.cancelConsultUrl + "' class='btn-link cancelConsult-btn'>해지 신청</a>";
            }
            if(data.contractInfo.cancelRequestYn == "Y") data.contractInfo.contractID += "<a href='" + data.contractInfo.cancelResultUrl + "' class='btn-link cancelConsultInquiry-btn'>신청 내역 조회</a>";
            
            if(data.contractInfo.contractType === 'C' || data.contractInfo.contDtlType === 'C00' ) {
                // 케어십, 무상케어십 - 의무사용기간 숨김
                $('.contract-info .dutyPeriod').hide();
                
                // 케어십 - 계약기간 표시형식 변경
                if(data.contractInfo.contractType === 'C' && data.contractInfo.contDtlType != 'C00'){
                	if(data.contractInfo.serviceTypeCd == '005'){
                		data.contractInfo.period =  '<div>'+data.contractInfo.period +' ~'+ data.contractInfo.contEndDate +'</div>';
                	}else{
                		 data.contractInfo.period =  '<div>'+data.contractInfo.period +' ~ </div>' + 
                         '<dl class="bullet-list nomargin-top">' +
                         '<dd class="b-txt">케어십 계약기간은 1년이며, 계약기간 만료 시점에 계약 해지 의사가 없을 시 최초 계약 기간만큼 자동 연장됩니다.</dd>' +
                         '</dl>';
                	}
                   
                } 
                // 계약기간 노출형식 : 년수(시작일 ~ 종료일)
                else {
                    var startArry = data.contractInfo.contStartDate.split('.');
                    var endArry = data.contractInfo.contEndDate.split('.');
                    var periodYear = endArry[0] - startArry[0];
                    data.contractInfo.period =  '<div>'+ periodYear +'년 ('+data.contractInfo.contStartDate  +' ~ ' + data.contractInfo.contEndDate +')</div>';
                }
            }
            // BTOCSITE-175 케어솔루션 > 무상케어십 정보 추가 노출 요청  : 비노출처리 : 계약서 발급신청버튼, 납부정보, 멤버십포인트 , 무상할인회차
            if( data.contractInfo.contDtlType === 'C00' ) {
                $('.contract-btn').hide();
                $('.sects.payment.viewer').hide();
                $('.member-point-info').hide();
                $('.tooltip-wrap.rental-tooltip').hide();
                $('.saleTurn').hide();
                $('.subsCategory').hide();
            } else {
                $('.contract-btn').show();
                $('.sects.payment.viewer').show();
                $('.member-point-info').show();
                $('.tooltip-wrap.rental-tooltip').show();
                $('.saleTurn').show();
                if (data.contractInfo.oriContNo != undefined && data.contractInfo.oriContNo != "" && data.contractInfo.oriContNo != null) {
                    $('.subsCategory').show();
                }else{
                    $('.subsCategory').hide();
                }
            }

            // 렌탈케어 - 의무 사용기간 포맷 변경
            if(data.contractInfo.dutyPeriod && data.contractInfo.contractType === 'R') {
                $('.contract-info .dutyPeriod').show();
                var dutyPeriod = data.contractInfo.dutyPeriod.split(" ");
                    dutyPeriod.push(vcui.date.calcDate(dutyPeriod[1].replace(/\./g,'-'), '+'+(365*Number(dutyPeriod[0].replace('년','')))+'d', 'yyyy.MM.dd'));
                    data.contractInfo.dutyPeriod = dutyPeriod[0]+'('+dutyPeriod[1]+' ~ '+dutyPeriod[2]+')';
            }

            // BTOCSITE-22701 차세대 계약건일 경우 계약기간,의무사용기간, 노출, 계좌이체 영역 미노출
            if (data.contractInfo.contGrpNo) {
                //업가전일때

                $('.contract-info .period').hide();
                $('.contract-info .dutyPeriod').hide();
                $('.modelName').hide();
                $('.installDate').hide();
                $('.sects.payment.new-form-style #bank').hide(); 
                $('.contStartDate').show()
                $('.latter-btnWarp li').eq(1).hide();
                
                //BTOCSITE-22701 :: 차세대 건일 경우 서비스명 -> 아이템명 노출
                $('.serviceName').hide()
                $('.serviceName dl dd').hide();
                $('.scModelNm').show();

            
            // 구독 서비스일경우 계약기간,의무사용기간,모델명,설치일,계좌이체 숨김처리
            }else if( data.contractInfo.contDtlType === 'C21') {
                $('.contract-info .period').hide();  //계약기간
                $('.contract-info .dutyPeriod').hide();  //의무사용기간
                $('.modelName').hide();  //모델명
                $('.installDate').hide();  //설치일
                $('.sects.payment.new-form-style #bank').hide();

                $('.serviceName').show(); //서비스명
                $('.contStartDate').show(); //계약 시작일자

                $('.latter-btnWarp li').eq(1).hide();   // 렌탈/케어쉽 배너 숨김처리
                $('.scModelNm').hide();
                $('#payday04').parent().show();
                $('#payday02').parent().show();

                
            }else{
                $('.contract-info .period').show();
                $('.contract-info .dutyPeriod').show();
                $('.modelName').show();
                $('.installDate').show();
                
                // BTOCSITE-59852 [마이페이지] 주문/배송/청약 조회 내, 납부변경 수단 변경의 건 - cms 어드민에서 조회된 카테고리만 계좌 이체 노출
                if(data.paymentInfo.accDispYn && data.paymentInfo.accDispYn === 'N'){
                    $('.sects.payment.new-form-style #bank').hide(); // 계좌이체 비노출 카테고리
                }else{
                	$('.sects.payment.new-form-style #bank').show();	
                }

                $('.serviceName').hide();
                $('.contStartDate').hide();
                
                $('.latter-btnWarp li').eq(1).show();
                $('.scModelNm').hide();
            }            


            changeFieldValue('contract-info', data.contractInfo);
    
            info = {
                monthlyPrice: "<span>" + data.paymentInfo.monthlyPrice + "</span><a href='" + data.paymentInfo.paymentListUrl  + "' class='btn-link paymenyList-btn'>납부내역 조회</a>",
                withdrawDate: data.paymentInfo.withdrawDate
            }
            if (data.paymentInfo.paymentMethodCode == PAYMENT_METHOD_CODE) { // BTOCSITE-11586 납부방법이 모두 동일하게 '계좌이체'로 출력되는 현상
                paymentMode = "card";
    
                info.paymentMethod = "신용카드"
                info.methodName =  "<span>" + data.paymentInfo.cardInfo.cardComName + "</span><a href='" + data.paymentInfo.requestCardUrl  + "' class='btn-link requestCard-btn'>제휴카드 간편 신청</a>";//BTOCSITE-17950
                info.methodNumber = txtMasking.card(data.paymentInfo.cardInfo.cardNumber);
            } else{
                paymentMode = "bank";
    
                info.paymentMethod = "계좌이체";
                info.methodName =  "<span>" + data.paymentInfo.bankInfo.bankName + "</span><a href='" + data.paymentInfo.requestCardUrl  + "' class='btn-link requestCard-btn'>제휴카드 간편 신청</a>";//BTOCSITE-17950
                info.methodNumber = txtMasking.substr(data.paymentInfo.bankInfo.bankNumber, 4);
            }
            transDay = data.paymentInfo.transDay;
            changeFieldValue('payment-info', info);
            if(data.paymentInfo.isGrouping || data.contractInfo.contStatus != "S"){
                $('.payment-info .requestCard-btn, .changePayment-btn').hide();
            } else{
                $('.payment-info .requestCard-btn, .changePayment-btn').show();
            }
            associCardType = data.paymentInfo.associCardType;
			associCardStatus = data.paymentInfo.associCardStatus; // 제휴카드신청현황 BTOCSITE-11663 마이페이지에서 제휴카드 신청 시 오류 발생

            // 구독서비스일경우 제휴카드 목록 업데이트
            if( data.contractInfo.contDtlType === 'C21' ) {
                var $select = $('[name="concertedCard"]');
                $select.empty();
                $select.append('<option value="" class="placeholder">선택</option>');
                
                data.partnerCardList.forEach(function( cardObj ){
                    $select.append('<option value="'+ cardObj.commonCodeId +'" class="placeholder">'+ cardObj.commonCodeName +'</option>');
                });

                $select.vcSelectbox('update');

            }

            var isAgreeText = "";
            var isAgree = data.memberPointInfo.isAgree;
            var deductype = data.memberPointInfo.deductType;
            var userpoint = data.memberPointInfo.userPoint;
            var deductpoint = data.memberPointInfo.deductPoint;
            var userpointComma = vcui.number.addComma(userpoint);
            var deductpointComma = vcui.number.addComma(deductpoint);
            var memPointAgreeDate = data.memberPointInfo.memPointAgreeDate;
            
            if(isAgree){
                isAgreeText = "동의 ("+data.memberPointInfo.memPointPayLimit+")";
                if(deductype == "deduct"){
                    $('.mempoint-info input[value=deduct]').prop('checked', true);
                } else{
                    $('.mempoint-info input[value=all]').prop('checked', true);
                }
                $('.mempoint-info .agreeBox').show();
                $('.mempoint-info .noneAgreeBox').hide();
            } else{
                isAgreeText = "미동의";
                $('.mempoint-info .agreeBox').hide();
                $('.mempoint-info .noneAgreeBox').show();
            }
            
            $('.mempoint-info').find('.userPoint').text(userpointComma);
            $('.mempoint-info').find('.deductPoint').text(deductpointComma);
            $('.mempoint-info').find('.viewer').text(isAgreeText);
            $('.mempoint-info').data('isAgree', isAgree);
            $('.mempoint-info').data('deductType', deductype);
            $('.mempoint-info').data('userPoint', userpoint);
            $('.mempoint-info').data('deductPoint', deductpoint);
            $('.mempoint-info').find('span.date').text(memPointAgreeDate);
            
            cancelMempointModify(false);

            changeFieldValue('manager-info', data.managerInfo);
            if(data.refundBankInfo) {  
                $('input[id=refund-bank1]').attr('value',data.userInfo.user.transMemNm);
                $('.sects.refund-bank-sects div.noData').hide();  
                $('.sects.refund-bank-sects div.dl-infolist-wrap').show();  
                $('.refund-bank-info').find('.lists').remove();
                var refundBankCode;
                
                $("#refund-bank2>option").map(function() {
                    if ($(this).val() == data.refundBankInfo.refundBankCode) {
                        refundBankCode = $(this).text();
                    }
                     return refundBankCode; 
                    });

                    if (data.refundBankInfo.refundAccountNum) {
                        var originStr = data.refundBankInfo.refundAccountNum;
                        var maskingStr = originStr.toString().replace(originStr, originStr.toString().replace(/(\d{5})(\d{4})(\d{4})/gi,'$1**-****-$3')); 

                        var listTableTemplate_1 =
                        '<ul class="lists"> '+                                               
                            ' <li>'+ 
                                '<dl>'+
                                    '<dt>예금주</dt>'+
                                    '<dd>' + data.userInfo.user.transMemNm + '</dd>'+
                                '</dl>'+
                            '</li>'+                                                
                            '<li>'+
                                '<dl>'+
                                    '<dt>은행명</dt>'+
                                    // '<dd>'  + data.refundBankInfo.refundBankCode + '</dd>'+
                                    '<dd>'  + refundBankCode + '</dd>'+
                                '</dl>'+
                            '</li>' +                                               
                            '<li>'+
                                '<dl>'+
                                    '<dt>계좌번호</dt>'+
                                    '<dd>'  + maskingStr + '</dd>'+
                                '</dl>'+
                            '</li>'+
                        '</ul>';
                        $('.refund-bank-info').append(listTableTemplate_1);

                    }else{
                        $('.sects.refund-bank-sects div.noData').show();
                        $('.sects.refund-bank-sects div.dl-infolist-wrap').hide();
                    }

        }
        //  else {
        //     $('.sects.refund-bank-sects div.noData').show();
        //     $('.sects.refund-bank-sects div.dl-infolist-wrap').hide();
        // }
            changeFieldValue('refund-bank-info', data.refundBankInfo);
                  
            userInfo = {
                userName: data.userInfo.user.name,
                userPhone: data.userInfo.user.phoneNumber,
                userTelephone: data.userInfo.user.telephoneNumber,
                userEmail: data.userInfo.user.email,
                userAdress: data.userInfo.user.adress,
                actualUserName: data.userInfo.actualUser.name,
                actualUserPhone: data.userInfo.actualUser.phoneNumber,
                actualUserTelephone: data.userInfo.actualUser.telephoneNumber,
                rcvPostCode: data.userInfo.actualUser.rcvPostCode,
                rcvBasAddr: data.userInfo.actualUser.rcvBasAddr,
                rcvDtlAddr: data.userInfo.actualUser.rcvDtlAddr,
                company : data.userInfo.user.company,
                businessType : data.userInfo.user.businessType,
                rprNm : data.userInfo.user.rprNm,
                bsnRgsNmb : data.userInfo.user.bsnRgsNmb,
                companyAdress : data.userInfo.user.companyAdress
                
            }
            userInfoValidation.setValues(userInfo);
    
            cardInfo = {
                paymentCard: data.paymentInfo.cardInfo.cardComValue,
                paymentCardNumber: data.paymentInfo.cardInfo.cardNumber,
                paymentCardPeriod: data.paymentInfo.cardInfo.cardPeriod,
                orgPaymentCard: data.paymentInfo.cardInfo.cardComValue,
                orgPaymentCardNumber: data.paymentInfo.cardInfo.cardNumber,
                orgPaymentCardPeriod : data.paymentInfo.cardInfo.cardPeriod
                
            }
            cardValidation.setValues(cardInfo);
            
    
            bankInfo = {
                paymentBank: data.paymentInfo.bankInfo.bankValue,
                paymentBankNumber: data.paymentInfo.bankInfo.bankNumber,
                paymentUserName: data.paymentInfo.bankInfo.bankUser,
                orgPaymentUserName : data.paymentInfo.bankInfo.bankUser,
                orgPaymentBankNumber : data.paymentInfo.bankInfo.bankNumber,
                orgPaymentBank : data.paymentInfo.bankInfo.bankValue
            }
            bankValidation.setValues(bankInfo);

            refundInfo = {
                bankAccount: !data.refundBankInfo ? "" : data.refundBankInfo.refundAccountNum ,
                bankCd: !data.refundBankInfo ? "" : data.refundBankInfo.refundBankCode
            }
            refundValidation.setValues(refundInfo);
            setPaymentModeCont();
			//BTOCSITE-15005 start
           if( data.contractInfo.contStatus === 'W' || data.contractInfo.platformType === 'KAKAO') { // 카카오일 경우 show() BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리
        	   mypage.find(".contractDayCnt").show();
        	   mypage.find(".contractDayCnt").empty().html(data.contractInfo.contractDayCnt);
           }else{
        	   mypage.find(".contractDayCnt").hide();         
           }
           //BTOCSITE-15005 END

        } else{
            mypage.find(".section-wrap").hide();

            mypage.find(".section-wrap").before('<div class="no-data"><p>보유하신 케어솔루션 계약 정보가 없습니다.</p></div>');
        }
        changeBusiness(data.contractInfo.custGb);
        
    }

    /* BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 */
    function setContractCare(data){
        mypage.find(".no-subscribe").remove();

        var $lc_select = $('select[name=contractInfo]').find('option:selected').val();
        var $lc_cont = $('.lb-container');

        //console.log("setContractInfo_의 데이터 %o",data);
        //console.log("셀렉", $lc_select);
        //mypage.find(".section-wrap").hide();
        //console.log("sssss", mypage.find(".section-wrap"))

        // 로컬 테스트용 BTOCSITE-3407 2022-02-11
        if(window.location.pathname == '/html/MYC/ACCF7025_care_benefits.html') {
            switch($lc_select.split('|')[1]) {
                case '20229019' :
                    data = {"contStartDate":"2020.02.07","modelName":"정수기(WQD74WJ5)","contractType":"R","contractID":"20229019","contDtlType":"R00","contEndDate":"2025.02.06"}
                    break;
                case '20228792' :
                    data = {"contStartDate":"2020.02.07","modelName":"공청기(AS117DWE)","contractType":"C","contractID":"20228792","contDtlType":"C09","contEndDate":"2025.03.12"}
                    break;
                case '20228793' :
                    data = {"contStartDate":"2021.02.07","modelName":"공청기(AS117DWE)","contractType":"C","contractID":"20228793","contDtlType":"C09","contEndDate":"2025.03.12"}
                    break;
                case '20229018' :
                    data = {"contStartDate":"2019.02.07","modelName":"정수기(WQD74WJ5)","contractType":"R","contractID":"20229018","contDtlType":"R00","contEndDate":"2024.02.06"}
                    break;
                case '12227003' :
                    data = {"contStartDate":"2018.02.07","modelName":"정수기(WD502AW)","contractType":"R","contractID":"12227003","contDtlType":"R00","contEndDate":"2023.02.06"}
                    break;
                case '11511425' :
                    data = {"contStartDate":"2017.02.07","modelName":"정수기(WD500AS)","contractType":"R","contractID":"11511425","contDtlType":"R00","contEndDate":"2022.02.06"}
                    break;
                case '11236397' :
                    data = {"contStartDate":"2016.05.07","modelName":"정수기(WD300AW)","contractType":"R","contractID":"11236397","contDtlType":"R00","contEndDate":"2021.05.06"}
                    break;
                case '12511183' :
                    data = {"contStartDate":"2018.04.30","modelName":"정수기(WD302AP)","contractType":"R","contractID":"12511183","contDtlType":"R00","contEndDate":"2023.04.29"}
                    break;
                default :
                    break;
            }
        }


        if(data != undefined && data != "" && data != null && $lc_select != ""){
            var info;
    
            mypage.find(".section-wrap").show();
            mypage.find(".lb-common").show();
        

            // S : BTOCSITE-3407 2022-02-11
            var validOpt = {
                num : (data.contractType === 'C')?3:3,
                str : new Date(Number(data.contStartDate.split('.')[0]), Number(data.contStartDate.split('.')[1]) - 1, Number(data.contStartDate.split('.')[2])),
                end : new Date(Number(data.contEndDate.split('.')[0]), Number(data.contEndDate.split('.')[1]) - 1, Number(data.contEndDate.split('.')[2])),
                format : function(d, f) {
                    return f.replace(/(yyyy|yy|mm|dd)/gi, function($1) {
                        switch ($1) {
                            case "yyyy": return d.getFullYear();
                            case "yy": return String("0" + (d.getFullYear() % 1000)).slice(-2);
                            case "mm": return String("0" + (d.getMonth() + 1)).slice(-2);
                            case "dd": return String("0" + (d.getDate())).slice(-2);
                            default: return $1;
                        }
                    });
                },
                call : function(str, end) {
                    var da1 = new Date(Number(str.split('.')[0]), Number(str.split('.')[1]) - 1, Number(str.split('.')[2]));
                    var da2 = new Date();
                    var dif = da2 - da1;
                    var cDay = 24 * 60 * 60 * 1000;// 시 * 분 * 초 * 밀리세컨
                    var cMonth = cDay * 30;// 월 만듬
                    var cYear = cMonth * 12; // 년 만듬
                    return {
                        year: parseInt(dif/cYear),
                        month: parseInt(dif/cMonth),
                        day: parseInt(dif/cDay),
                    }
                }
            }
            if((data.contractType === 'C')) {
                validOpt.str.setFullYear(validOpt.str.getFullYear() + 1)
                validOpt.str.setMonth(validOpt.str.getMonth() + validOpt.num)
                validOpt.endDate = new Date(validOpt.str.getFullYear(), validOpt.str.getMonth(), 0);
                validOpt.strDate = new Date(Number(data.contStartDate.split('.')[0]), Number(data.contStartDate.split('.')[1]) - 1, Number(data.contStartDate.split('.')[2]));
            }else {
                validOpt.str.setMonth(validOpt.str.getMonth() + validOpt.num)
                validOpt.endDate = new Date(new Date().getFullYear(), validOpt.str.getMonth(), 0);
                validOpt.strDate = new Date(new Date().getFullYear(), new Date(Number(data.contStartDate.split('.')[0]), Number(data.contStartDate.split('.')[1]) - 1, Number(data.contStartDate.split('.')[2])).getMonth(), 1);
                // validOpt.call(data.contStartDate)
            }
            data.validStrDate = validOpt.format(validOpt.strDate, 'yyyy.mm.dd');
            data.validEndDate = validOpt.format(validOpt.endDate, 'yyyy.mm.dd');

            // console.log(validOpt, validOpt.call(data.contStartDate), data)
            //<!-- BTOCSITE-60709 [구독-마이페이지] 연차 별 혜택 수정의 건 -->
            // 계약 종료 3개월 전 1일 부터 종료일 까지 
            var last3MonthStrDt = new Date(Number(data.contEndDate.split('.')[0]), Number(data.contEndDate.split('.')[1]) - 4, 1);
            var last3MonthEndDt = new Date(Number(data.contEndDate.split('.')[0]), Number(data.contEndDate.split('.')[1]) - 1, Number(data.contEndDate.split('.')[2]));
            var toDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            
            if((data.contractType === 'C')) {
                if(validOpt.call(data.contStartDate).month <= 14) { // 케어십  1. 가입 1년차 시점부터 만 14개월 말일까지
                    return $lc_cont.html(vcui.template(lb_careShip, data));
                }else if(validOpt.call(data.contStartDate).month >= 57 && validOpt.call(data.contStartDate).month <= 60){ // 2. 계약 종료 5년차(57개월)부터 3개월간  
                    data.validStrDate = validOpt.format(last3MonthStrDt, 'yyyy.mm.dd');
                    data.validEndDate = validOpt.format(last3MonthEndDt, 'yyyy.mm.dd');
                    return $lc_cont.html(vcui.template(eval('lb_careSolution_5'), data));
                }else{
                    mypage.find(".lb-container").empty();	
                }
            } else {
                if(12 <= validOpt.call(data.contStartDate).month && validOpt.call(data.contStartDate).month <= 14) { //가전구독  1.가입 1년차 시점부터 만 14개월 말일까지 
                    return $lc_cont.html(vcui.template(eval('lb_careSolution_1'), data));
                }else{
                    if(data.subScriptionBenefitsYN === 'Y'){ // 2.계약종료 3개월 전의 1일에(ex. 8월 15일 만기일 경우 5월 1일부터 노출) 노출
                        data.validStrDate = validOpt.format(last3MonthStrDt, 'yyyy.mm.dd');
                        data.validEndDate = validOpt.format(last3MonthEndDt, 'yyyy.mm.dd');
                        return $lc_cont.html(vcui.template(eval('lb_subscription_5'), data));
                    }else{
                        mypage.find(".lb-container").empty();	
                    }
                } 
            }
            //<!-- //BTOCSITE-60709 [구독-마이페이지] 연차 별 혜택 수정의 건 -->
            // E : BTOCSITE-3407 2022-02-11
           
            //setPaymentModeCont();
			// BTOCSITE-13831 start
            //if(mypage.hasClass("contractDayCnt") == true) {
            	mypage.find(".contractDayCnt").show();                
                mypage.find(".contractDayCnt").empty().html(data.contractDayCnt);
              
            //}
            // BTOCSITE-13831 start

        } else{
            mypage.find(".section-wrap").hide();
            mypage.find(".lb-container").empty();
            //mypage.find(".lb-common").hide();

		//setPaymentModeCont();
        // BTOCSITE-13831 start
        //if(mypage.hasClass("contractDayCnt") == true) {
        	mypage.find(".contractDayCnt").hide();
        //}
        // BTOCSITE-13831 start

            mypage.find(".section-wrap").before('<div class="no-data"><p>보유하신 케어솔루션 계약 정보가 없습니다.</p></div>');
        }
    }
    /* //BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 */

    function setPaymentModeCont(){
        $('.mypage .section-wrap .sects.payment.new-form-style input[data-visible-target]').prop("checked", false);
        $('.mypage .section-wrap .sects.payment.new-form-style input[data-visible-target=".by-' + paymentMode + '"]').prop("checked", true);

        $('.mypage .section-wrap .sects.payment.new-form-style').find('.tab-panel').hide();
        $('.mypage .section-wrap .sects.payment.new-form-style').find('.tab-panel.by-' + paymentMode).show();
    }

    function changePaymentMode(payment){
        $('.mypage .section-wrap .sects.payment.new-form-style input[data-visible-target]').prop("checked", false);
        $('.mypage .section-wrap .sects.payment.new-form-style input[data-visible-target=".by-' + payment + '"]').prop("checked", true);

        $('.mypage .section-wrap .sects.payment.new-form-style').find('.tab-panel').hide();
        $('.mypage .section-wrap .sects.payment.new-form-style').find('.tab-panel.by-' + payment).show();
    }

    function getMaskingData(data){
        var newdata = {};
        for(var key in data){
            if(key == "name") newdata[key] = data[key];
            else if(key == "email") newdata[key] = data[key];
            else if(key == "adress") newdata[key] = data[key], 20;
            else newdata[key] = data[key];
        }

        return newdata;
    }

    function changeContractInfo(){
        lgkorUI.showLoading();

        var info = $('select[name=contractInfo]').find('option:selected').val();

        saveUserInfoCancel();

        paymentInfoBlock.show();
        paymentModifyBlock.hide();

        refundBlock.show();
        refundModifyBlock.hide();
        refundBtn.hide();

        var sendata = {
            contractInfo: info
        }
        
        $('input[name=changeBtn]').prop('checked',false);
        $('#payDay').hide();
        $('#inputPayDat').show();
        transDayChangeYN = "N";
        
        lgkorUI.requestAjaxData(CONTRACT_INFO, sendata, function(result){
            //환불 계좌 sendata 파라미터
            refundSaveContractID = result.data.contractInfo.contractID;

            newg = result.data;
            setContractInfo(result.data);       
            
            // BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 START
            contInfo = result.data.contractInfo; // 현재 선택된 계약정보
            if (contInfo.platformType != undefined && contInfo.platformType == 'KAKAO') {
            	$('.kakaoTxt').show();
            } else {
            	$('.kakaoTxt').hide();
            }
            // BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 END            
            /*<c:if test="${contractInfo.custGb == 'O'}"><span class="flag-wrap"><span class="flag">사업자</span></span></c:if>*/
            //BTOCSITE-TOCSITE-63089 [주문] [구독 Task] Sales - 임직원가 적용
            if (contInfo.empType == "A") {
                $('#contEmpTxt').html('<span class="flag-wrap"><span class="flag">임직원</span></span>');
            } else if (contInfo.empType == "B"){
                $('#contEmpTxt').html('<span class="flag-wrap"><span class="flag">복지몰</span></span>');
            } else if(contInfo.custGb == "O"){
                $('#contEmpTxt').html('<span class="flag-wrap"><span class="flag">사업자</span></span>');
            } else {
				$('#contEmpTxt').html('<span></span>');
			}
            //BTOCSITE-TOCSITE-63089 [주문] [구독 Task] Sales - 임직원가 적용
            lgkorUI.hideLoading();
            if(requestPartnerCardYn == "Y"){
                requestPartnerCardYn = "";

                var viewertop = $('.sects.payment.viewer').offset().top;
                $('html, body').animate({scrollTop:viewertop}, 200, function(){
                    setTimeout(function(){
                        setRequestCard();
                    }, 100);
                });
            } else{
                // BTOCSITE-2838 : 고객혜택에서 왔을때  매니저 정보로 이동 s
                var managerInfoLink= 'managerInfoLink';
                    if (lgkorUI.getStorage('managerInfoLink') == true){ 
                        if ($('.section-inner').hasClass('manager-info') == true) {
                            var managerInfoPosition = document.querySelector('.manager-info').offsetTop;
                            $('html, body').animate({scrollTop:managerInfoPosition - 70}, 0);
                        }       
                        lgkorUI.removeStorage(managerInfoLink);
                    } else {
                        // BTOCSITE-72164 [ARS 대응]"납부정보변경" 메뉴 클릭 시 납부정보영역으로 자동 Focus 
                        if($(location).attr('href').indexOf('paymentarea=Y') > -1){
                            var viewertop = $('.sects.payment.viewer').offset().top;
                            $('html, body').animate({scrollTop:viewertop}, 200);
                        } else {
                            lgkorUI.removeStorage(managerInfoLink);
                            $('html, body').animate({scrollTop:0}, 220);
                        }
                    }
                // BTOCSITE-2838 :고객혜택에서 왔을때  매니저 정보로 이동 e
            }
        }, ajaxMethod);

        /* BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 */
        lgkorUI.requestAjaxData(CONTRACT_CARE, sendata, function(result){

            // console.log("result_1111111 %o",result);
            // console.log("test", lb_careShip);
            // console.log("changeContractInfo의 select", sendata);

            setContractCare(result.data);

            $('.contents.mypage').find('.btn.border.size-m.arrow').on('click', function (e) {
                sessionStorage.setItem("enterReOrderBenefit", "Y");
                window.location.href = "/care-solutions";
            });

            lgkorUI.hideLoading();

            //BTOCSITE-3407 삭제
            // if(requestPartnerCardYn == "Y"){
            //     requestPartnerCardYn = "";

            //     var viewertop = $('.sects.payment.viewer').offset().top;
            //     $('html, body').animate({scrollTop:viewertop}, 200, function(){
            //         setTimeout(function(){
            //             setRequestCard();
            //         }, 100);
            //     });
            // } else {
            //     // BTOCSITE-2838 : 고객혜택에서 왔을때  매니저 정보로 이동 s
            //     var managerInfoLink= 'managerInfoLink';
            //         if (lgkorUI.getStorage('managerInfoLink') == true){ 
            //             if ($('.section-inner').hasClass('manager-info') == true) {
            //                 var managerInfoPosition = document.querySelector('.manager-info').offsetTop;
            //                 $('html, body').animate({scrollTop:managerInfoPosition - 70}, 0);
            //             }       
            //             lgkorUI.removeStorage(managerInfoLink);
            //         } else {
            //             lgkorUI.removeStorage(managerInfoLink);
            //             $('html, body').animate({scrollTop:0}, 220);
            //         }
            //     // BTOCSITE-2838 :고객혜택에서 왔을때  매니저 정보로 이동 e
            // }
        }, ajaxMethod);
        /* //BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 */
        $('select[name=contractInfo]').focus;
    }

    function setHiddenData(iptname, value){
        var ipt = $('.hidden-input-group').find('input[name=' + iptname + ']');
        ipt.val(value);
    }
    function getHiddenData(iptname){
        var ipt = $('.hidden-input-group').find('input[name=' + iptname + ']');
        return ipt.val();
    }
    
    function fnKakaoSubscribeOnCheck(btnName) {
    	// BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 START
    	// 카카오 구독 ON 계약일경우 납부 정보변경, 멤버십 포인트 차감동의 불가
    	if (contInfo.platformType != undefined && contInfo.platformType == 'KAKAO') {
    		
    		var strTitle = "";
    		
    		if (btnName == 'changePaymentBtn') {
        		strTitle = "카카오 구독ON에서 납부 정보변경이<br>가능합니다."
        	} else if (btnName == 'mempointBtn') {
        		strTitle = "카카오 구독ON에서 요금 납부가<br>가능합니다."
        	}
    		
    		lgkorUI.alert("", {
                title : strTitle 
            })
            
            return true;
    	}
    	// BTOCSITE-15958 [IDX80] 카카오 ON 채널을 통한 계약자의 납부정보 변경 및 멤버십 포인트 결제동의 불가 처리 END    
    }

    document.addEventListener('DOMContentLoaded', function () {
        init();
    });

     /* BTOCSITE-5138 210906 마이페이지>렌탈/케어>고객 실사용자 주소 변경 기능 추가 */
     $(function () {
        /* BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 - 링크 경로로 해당 스크립트 돌도록 삭제 */
        var cl_benefisLocation = $(location).attr('href');

        //오류가 있다면 indexOf URL 경로를 확인 해야함
        if (cl_benefisLocation.indexOf('benefits') == -1) {
            var addressFinder = new AddressFind();

            $('#addrBtn').on('click', function(e){
                addressFinder.modal(function(data){
                    $('input[name=rcvPostCode]').val(data.zonecode);
                    $('input[name=rcvBasAddr]').val(data.roadAddress);
                    
                    // 상세정보로 포커스 이동
                    $('input[name=rcvDtlAddr]').focus();
                    $('input[name=rcvDtlAddr]').val('');
                });
            });
        } 

        //분기 태움
        // var addressFinder = new AddressFind();

        // $('#addrBtn').on('click', function(e){
        //     addressFinder.open(function(data){
        //         $('input[name=rcvPostCode]').val(data.zonecode);
        //         $('input[name=rcvBasAddr]').val(data.roadAddress);
                
        //         // 상세정보로 포커스 이동
        //         $('input[name=rcvDtlAddr]').focus();
        //         $('input[name=rcvDtlAddr]').val('');
        //     });
        // });
    });
    /* //BTOCSITE-5138 210906 마이페이지>렌탈/케어>고객 실사용자 주소 변경 기능 추가 */

    /* //BTOCSITE-3407 케어솔루션 레터 및 연차별 혜택 메뉴(페이지)생성 - 링크 경로로 해당 스크립트 돌도록 삭제 */
    
    // BTOCSITE-18946 하단탭바 미노출 처리	
    function toggleAppBottomMenu(e, data) {
        // 닫기 시 앱 하단 복구
        $(e.target).one("modalhide", function (e) {
            lgkorUI.showAppBottomMenu(true);
            lgkorUI.setEnableAppScrollBottomMenu(true);
        });
        // 앱 하단바 숨김
        lgkorUI.showAppBottomMenu(false);
        lgkorUI.setEnableAppScrollBottomMenu(false);
    }

    function changeMaskingText(ipt){
        var leng, i, str;
        var attrName = $(ipt).attr('name');
        var value = $(ipt).val().replace(/ /gi, '').replace(/[^0-9.;\*]/g,'');
        var maskingStr = "";
        switch(attrName){
            case 'paymentCardNumber':
                leng = value.length <  16 ? value.length : 16;
                for(i=0;i< leng;i++){
                    str = i > 3 && i <  12 ? "*" : value.substr(i, 1);
                    maskingStr += str;
                }
                break;

            case 'paymentCardPeriod':
                leng = value.length <  4 ? value.length : 4;
                for(i=0;i< leng;i++){
                    str = i > 1 ? "*" : value.substr(i, 1);
                    maskingStr += str;
                }
                break;

            case 'paymentBankNumber':
                leng = value.length;
                for(i=0;i< leng;i++){
                    str = i > 5 ? "*" : value.substr(i, 1);
                    maskingStr += str;
                }
                break;
        }

        $(ipt).data('realData', value);
        $(ipt).val(maskingStr);
    }
    
    function changeBusiness(custGb){
        if("O" == custGb){
            $('#business').show();
            $('#businessTax').show();
            $('#memberPointBtn').hide();
            $('#memPointBusinessTxt').show();
            $('memPointInfo').className ="sects member-point-info";
            $('#memPointInfolistWrap').hide();
            $('#memPointTopBorder').hide();
            $('#memPointSaveBtn').hide();
            $('#latterBtn').hide();
        }else{
            $('#business').hide();
            $('#businessTax').hide();
            $('#memberPointBtn').show();
            $('#memPointBusinessTxt').hide();
            $('memPointInfo').className ="sects member-point-info new-form-style";
            $('#memPointInfolistWrap').show();
            $('#memPointTopBorder').show();
            //$('#memPointSaveBtn').show();
            $('#latterBtn').show();
        }
    }
    
})();